@charset "UTF-8";

/* src/app/email-campaign/email-campaign-candidate-slider/email-campaign-candidate-slider.component.scss */
.margin-auto {
  margin: auto !important;
}
.wc-my-auto {
  margin-bottom: auto !important;
  margin-top: auto !important;
}
.ml--1 {
  margin-left: -1px;
}
.ml--2 {
  margin-left: -2px;
}
.ml--3 {
  margin-left: -3px;
}
.ml--4 {
  margin-left: -4px;
}
.ml--5 {
  margin-left: -5px;
}
.ml--6 {
  margin-left: -6px;
}
.ml--7 {
  margin-left: -7px;
}
.ml--8 {
  margin-left: -8px;
}
.ml--9 {
  margin-left: -9px;
}
.ml--10 {
  margin-left: -10px;
}
.ml--15 {
  margin-left: -15px;
}
.mr--5 {
  margin-right: -5px;
}
.mr--10 {
  margin-right: -10px;
}
.mr--15 {
  margin-right: -15px;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.mt-0 {
  margin-top: 0 !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.ml-0 {
  margin-left: 0 !important;
}
.mr-0 {
  margin-right: 0 !important;
}
.m-1 {
  margin: 5px !important;
}
.my-1 {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.mx-1 {
  margin-left: 5px !important;
  margin-right: 5px !important;
}
.mt-1 {
  margin-top: 5px !important;
}
.mb-1 {
  margin-bottom: 5px !important;
}
.ml-1 {
  margin-left: 5px !important;
}
.mr-1 {
  margin-right: 5px !important;
}
.mb-1-5 {
  margin-bottom: 7.5px !important;
}
.m-2 {
  margin: 10px !important;
}
.my-2 {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.mx-2 {
  margin-left: 10px !important;
  margin-right: 10px !important;
}
.mt-2 {
  margin-top: 10px !important;
}
.mb-2 {
  margin-bottom: 10px !important;
}
.ml-2 {
  margin-left: 10px !important;
}
.mr-2 {
  margin-right: 10px !important;
}
.m-3 {
  margin: 15px !important;
}
.my-3 {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}
.mx-3 {
  margin-left: 15px !important;
  margin-right: 15px !important;
}
.mt-3 {
  margin-top: 15px !important;
}
.mb-3 {
  margin-bottom: 15px !important;
}
.ml-3 {
  margin-left: 15px !important;
}
.mr-3 {
  margin-right: 15px !important;
}
.m-4 {
  margin: 20px !important;
}
.my-4 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}
.mx-4 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}
.mt-4 {
  margin-top: 20px !important;
}
.mb-4 {
  margin-bottom: 20px !important;
}
.ml-4 {
  margin-left: 20px !important;
}
.mr-4 {
  margin-right: 20px !important;
}
.m-5 {
  margin: 25px !important;
}
.my-5 {
  margin-top: 25px !important;
  margin-bottom: 25px !important;
}
.mx-5 {
  margin-left: 25px !important;
  margin-right: 25px !important;
}
.mt-5 {
  margin-top: 25px !important;
}
.mb-5 {
  margin-bottom: 25px !important;
}
.ml-5 {
  margin-left: 25px !important;
}
.mr-5 {
  margin-right: 25px !important;
}
.m-6 {
  margin: 30px !important;
}
.my-6 {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}
.mx-6 {
  margin-left: 30px !important;
  margin-right: 30px !important;
}
.mt-6 {
  margin-top: 30px !important;
}
.mb-6 {
  margin-bottom: 30px !important;
}
.ml-6 {
  margin-left: 30px !important;
}
.mr-6 {
  margin-right: 30px !important;
}
.mb-8 {
  margin-bottom: 40px !important;
}
.p-0 {
  padding: 0 !important;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.pt-0 {
  padding-top: 0 !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.pr-0 {
  padding-right: 0 !important;
}
.p-1 {
  padding: 5px !important;
}
.py-1 {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.px-1 {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.pt-1 {
  padding-top: 5px !important;
}
.pb-1 {
  padding-bottom: 5px !important;
}
.pl-1 {
  padding-left: 5px !important;
}
.pr-1 {
  padding-right: 5px !important;
}
.p-2 {
  padding: 10px !important;
}
.py-2 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.px-2 {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.pt-2 {
  padding-top: 10px !important;
}
.pb-2 {
  padding-bottom: 10px !important;
}
.pl-2 {
  padding-left: 10px !important;
}
.pr-2 {
  padding-right: 10px !important;
}
.p-3 {
  padding: 15px !important;
}
.py-3 {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.px-3 {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.pt-3 {
  padding-top: 15px !important;
}
.pb-3 {
  padding-bottom: 15px !important;
}
.pl-3 {
  padding-left: 15px !important;
}
.pr-3 {
  padding-right: 15px !important;
}
.p-4 {
  padding: 20px !important;
}
.py-4 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
.px-4 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.pt-4 {
  padding-top: 20px !important;
}
.pb-4 {
  padding-bottom: 20px !important;
}
.pl-4 {
  padding-left: 20px !important;
}
.pr-4 {
  padding-right: 20px !important;
}
.p-5 {
  padding: 25px !important;
}
.py-5 {
  padding-top: 25px !important;
  padding-bottom: 25px !important;
}
.px-5 {
  padding-left: 25px !important;
  padding-right: 25px !important;
}
.pt-5 {
  padding-top: 25px !important;
}
.pb-5 {
  padding-bottom: 25px !important;
}
.pl-5 {
  padding-left: 25px !important;
}
.pr-5 {
  padding-right: 25px !important;
}
.p-6 {
  padding: 30px !important;
}
.py-6 {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}
.px-6 {
  padding-left: 30px !important;
  padding-right: 30px !important;
}
.pt-6 {
  padding-top: 30px !important;
}
.pb-6 {
  padding-bottom: 30px !important;
}
.pl-6 {
  padding-left: 30px !important;
}
.pr-6 {
  padding-right: 30px !important;
}
.px-7 {
  padding-left: 35px !important;
  padding-right: 35px !important;
}
.py-7 {
  padding-top: 35px !important;
  padding-bottom: 35px !important;
}
.pb-7 {
  padding-bottom: 35px !important;
}
.px-8 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}
.py-8 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}
.pb-8 {
  padding-bottom: 40px !important;
}
.pt-8 {
  padding-top: 40px !important;
}
.text-justify {
  text-align: justify !important;
}
.text-wrap {
  white-space: normal !important;
}
.text-nowrap {
  white-space: nowrap !important;
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
.text-lowercase {
  text-transform: lowercase !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.font-weight-light {
  font-weight: 300 !important;
}
.font-weight-lighter {
  font-weight: lighter !important;
}
.font-weight-normal {
  font-weight: 400 !important;
}
.font-weight-500 {
  font-weight: 500 !important;
}
.font-weight-600 {
  font-weight: 600 !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.font-weight-bolder {
  font-weight: bolder !important;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  display: block;
  color: #000;
}
.text-blue {
  color: #2e93a1 !important;
}
.text-green {
  color: #229300;
}
.text-danger {
  color: #DE0000;
}
.text-defualt {
  color: #484b59;
  font-weight: 100;
}
.gray-text {
  color: #777777;
}
.text-light-grey {
  color: #949494 !important;
}
.text-white {
  color: #fff;
}
.text-black {
  color: #484b59 !important;
}
.text-orange {
  color: #FF9B05 !important;
}
.text-pink {
  color: #e85d75;
}
.text-dis {
  color: #CCCCCC;
}
.text-light-blue {
  color: #8fdde4;
}
.text-light-orange {
  color: #ffcd82;
}
.text-light-purple {
  color: #d6bdff;
}
.text-6767 {
  color: #676767;
}
.text-warning {
  color: #FFC400 !important;
}
a {
  color: #4dc7f4;
  outline: none;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  cursor: pointer;
  color: #4dc7f4;
}
.spacer {
  width: 1px;
  height: 1px;
}
.spacer2 {
  width: 1px;
}
.wc-d-block {
  display: block;
}
.wc-d-inline {
  display: inline;
}
.wc-d-inline-block {
  display: inline-block;
}
.wc-label {
  display: block;
  font-size: 14px;
  color: #000;
  padding-bottom: 5px;
}
.wc-form-control {
  border-radius: 2px;
  border: 2px solid #d6dde6;
  font-size: 14px;
  line-height: 1.2;
  padding: 6px 12px;
  height: 36px;
  width: 100%;
}
.wc-form-control:focus {
  border-color: #2e93a1;
  outline: none;
}
.wc-textarea {
  height: 100%;
}
.hr-color {
  border-bottom: 1px solid #676767;
}
.hr-color .wc-hr {
  display: inline;
}
.w-100 {
  width: 100%;
}
.h-15 {
  height: 18px;
}
.f-8 {
  font-size: 8px;
  line-height: 1.3;
}
.f-10 {
  font-size: 10px;
  line-height: 1.3;
}
.f-11 {
  font-size: 11px;
  line-height: 1.3;
}
.f-12 {
  font-size: 12px;
  line-height: 1.3;
}
.f-16 {
  font-size: 16px;
  line-height: 1.3;
}
.f-14 {
  font-size: 14px;
  line-height: 1.3;
}
.f-18 {
  font-size: 18px;
  line-height: 1.3;
}
.f-20 {
  font-size: 20px;
  line-height: 1.3;
}
.f-22 {
  font-size: 22px;
  line-height: 1.3;
}
.f-24 {
  font-size: 24px;
  line-height: 1.3;
}
.f-26 {
  font-size: 26px;
  line-height: 1.3;
}
.f-28 {
  font-size: 28px;
  line-height: 1.3;
}
.f-30 {
  font-size: 30px;
  line-height: 1.3;
}
.f-32 {
  font-size: 32px;
  line-height: 1.3;
}
.sep-tag {
  color: #676767;
  font-weight: 500;
  padding-bottom: 15px;
  background-color: #fff;
}
.category {
  color: #949494;
  font-weight: 500;
}
.wc-select {
  background-color: #fff;
  color: #676767;
}
.wc-select option {
  color: #484b59;
}
.wc-select option:disabled {
  color: #676767;
}
.wc-float-right {
  float: right;
}
.wc-float-left {
  float: left;
}
.wc-sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 60px;
  z-index: 1020;
  padding-top: 20px;
  padding-bottom: 40px;
  background-color: #fff;
  transition: all 0.3s;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.wc-upload-btn {
  width: 100px;
  height: 100px;
  border: 1px solid #777777;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  background-color: white;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.wc-upload-btn i {
  font-size: 16px;
  color: #2e93a1;
  position: relative;
  top: 45px;
  color: #2e93a1;
}
.wc-upload-btn .upload-sign {
  position: relative;
  top: 48px;
}
.wc-upload-btn input {
  position: absolute;
  cursor: pointer;
  font-size: 50px;
  opacity: 0;
  right: 0;
  top: 0;
}
.b {
  border: none;
}
.bl,
.bx {
  border-left: none;
}
.br,
.bx {
  border-right: none;
}
.bt,
.by {
  border-top: none;
}
.bb,
.by {
  border-bottom: none;
}
.wc-border {
  border: 1px solid #d1d1d1;
}
.wc-gray-border {
  border: 1px solid #484b59;
}
.br-0 {
  border-radius: inherit !important;
}
.brr-0 {
  border-top-right-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.brl-0 {
  border-top-left-radius: inherit !important;
  border-bottom-left-radius: inherit !important;
}
.brt-0 {
  border-top-left-radius: inherit !important;
  border-top-right-radius: inherit !important;
}
.brb-0 {
  border-bottom-left-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 16px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  background-color: white;
  border: 2px solid #777777;
  box-sizing: border-box;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: -1px;
  bottom: 0px;
  background-color: #777777;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: white;
  border-color: #80d7f8;
}
input:focus + .slider {
  box-shadow: 0 0 1px #80d7f8;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
  left: -10px;
  margin-right: -4px;
  background-color: #80d7f8;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.forms-top-header {
  width: calc(100% - 145px);
  position: fixed;
  top: 60px;
  margin: 0;
  padding: 20px 0 20px 0;
  background-color: #fff;
  z-index: 2;
}
.main-form {
  position: relative;
  top: 100px;
}
.wc-btn:hover {
  color: #ffffff;
  background-color: #206C79;
}
.wc-btn:focus {
  outline: none;
}
.wc-btn {
  padding: 7px 21px;
  color: #ffffff;
  font-weight: 100;
  border-radius: 2px;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-xs {
  padding: 3px 20px;
  border-radius: 16px;
  color: #ffffff;
  font-weight: 600;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-validate {
  background-color: #4a90e2;
}
.wc-btn-registered {
  background-color: #ffcd82;
}
.wc-primary {
  background-color: #2e93a1;
}
.wc-gray-btn {
  background-color: #999999;
}
.wc-white-btn {
  background-color: #fff;
  color: #484b59;
  border: 2px solid #d6dde6 !important;
}
.wc-primary {
  background-color: #2e93a1;
}
.line-height-1 {
  line-height: 1.6;
}
.line-height {
  line-height: 0px;
}
.hc {
  color: #484b59;
}
.bg-blue {
  background-color: #2E93A1;
}
.bg-blue-light {
  background-color: #b3e7fa;
}
.bg-blue-dark {
  background-color: #4a90e2;
}
.bg-blue-2 {
  background-color: #8fdde4;
}
.bg-orange {
  background-color: #FF9B05;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-gray {
  background-color: #fafafc !important;
}
.bg-gray-dark-2 {
  background-color: #d6dde6;
}
.bg-gray-dark {
  background-color: #d1d1d1;
}
.bg-gray-light {
  background-color: #fafafc;
}
.bg-red-light {
  background-color: #ead1d2;
}
.bg-red {
  background-color: #DE0000;
}
.bg-white {
  background-color: #ffffff;
}
.bg-green {
  background-color: #229300;
}
.bg-brawn {
  background-color: #cbaea5;
}
.bg-black {
  background-color: #484b59;
}
.nobg {
  background-color: transparent;
}
.btn-bg-black {
  background-color: #334059;
}
.btn-interview {
  padding: 8px 15px;
  letter-spacing: 4;
  color: #586e9a;
  border-radius: 2px;
  border: solid 1px #586e9a;
  transition: all 0.5s;
  background-color: #ffffff;
}
.btn-interview:hover,
.btn-interview:active,
.btn-interview:focus {
  color: #ffffff;
  border: solid 1px #586e9a;
  background-color: #586e9a;
}
.red-border {
  border: 1px solid #DE0000;
}
.blue-border {
  border: 1px solid #2e93a1;
}
.black-border {
  border: solid 1px #2C2C2C;
}
.border-stepper {
  border: solid 1px #334059;
}
.step-gray-border {
  border: solid 1px #d1d1d1;
}
.gt {
  color: #999999;
}
.text-blue-gray {
  color: #8094B1;
}
.light-blue-text {
  color: #012964;
}
.black-text {
  color: #000;
}
.green-text {
  color: #4ac98d;
}
.wccard {
  border-radius: 2px;
  background-color: #fff;
}
.wc-border {
  border: 2px solid #ECF0F4;
}
.wc-bl {
  border-left: 2px solid #ECF0F4;
}
.wc-br {
  border-right: 2px solid #ECF0F4;
}
.wc-bt {
  border-top: 2px solid #ECF0F4;
}
.wc-bb {
  border-bottom: 2px solid #ECF0F4;
}
.bg-warning {
  background-color: #FFC400;
}
.bg-light-green {
  background-color: #d3e9cc;
}
.bg-light-red {
  background-color: rgba(222, 0, 0, 0.2);
}
.paused-color {
  background-color: #FFF3CC;
}
.bg-img {
  background-color: #f5f6f9;
}
.hrcolor {
  border-top: 1px solid #ECF0F4;
}
.z-1 {
  z-index: -1;
}
.z0 {
  z-index: 0;
}
.z1 {
  z-index: 1;
}
.z2 {
  z-index: 2;
}
.z3 {
  z-index: 3;
}
.z4 {
  z-index: 4;
}
.z5 {
  z-index: 5;
}
.wc-box-shadow,
.wc-dropdwon-box.show {
  box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
}
.pointer {
  cursor: pointer;
}
.c-logo {
  width: 50px;
  height: 50px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-mini {
  width: 30px;
  height: 30px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo-mini img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md {
  width: 80px;
  height: 80px;
  background-color: rgba(48, 5, 127, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 24px;
}
.c-logo-md img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md i {
  font-size: 40px;
}
.showpassword {
  position: absolute;
  top: 10px;
  right: 4%;
}
.listStyleBullet > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.listStyleBullet > ul li {
  padding: 2px 0;
}
.listStyleBullet div > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.strikethrough {
  text-decoration: line-through;
  color: #999999;
}
.anchor-text {
  color: #4dc7f4 !important;
}
.tl0 {
  top: 0;
  left: 0;
}
.tr0 {
  top: 0;
  right: 0;
}
.ats-cta-btn:hover i {
  color: #206C79;
}
.ats-cta-btn {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background-color: #D5E9EC;
  padding: 5px 8px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.ats-cta-btn i {
  color: #2E93A1;
  font-size: 14px;
  font-weight: 600;
}
.wc-progress-profile {
  background-color: rgba(103, 198, 187, 0.2);
  border-radius: 1rem;
}
.wc-progress-profile .wc-progress-bar {
  background-color: rgb(103, 198, 187);
}
.mt-3px {
  margin-top: 3px;
}
.mb-3px {
  margin-bottom: 1px;
}
label {
  font-size: 12px;
}
.no-outline {
  outline: none;
}
input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration {
  display: none;
}
.text-484b59 {
  color: #484b59;
}
.yrofexp {
  width: 160px;
  float: left;
}
.yrofexp input[type=number] {
  width: 60px;
  float: left;
  z-index: 2;
  position: relative;
  font-size: 14px;
}
.yrofexp input[type=text] {
  width: 90px;
  float: left;
  z-index: 2;
  margin-left: -2px;
  text-align: center;
}
.yrofexp input[type=text]:focus {
  border: 2px solid #d6dde6;
}
.yrofexp label {
  width: 100px;
  float: left;
  padding: 7.5px 12px;
  border: 2px solid #d6dde6;
  margin-left: -2px;
  border-radius: 0 2px 2px 0;
  color: #000;
  text-align: center;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
.form-control-sm::-webkit-inner-spin-button,
.form-control-sm::-webkit-outer-spin-button {
  -webkit-appearance: auto !important;
  appearance: auto !important;
  margin: 0;
}
.upload-container {
  width: 100%;
  float: left;
  height: 80px;
  color: #2e93a1;
  border: 2px solid #fafafc;
  cursor: pointer;
  position: relative;
  transition: 0.4s;
  border-radius: 2px;
}
.upload-container .upload--btn {
  width: 76px;
  height: 100%;
  padding: 22px 30px;
  background-color: #fafafc;
  font-size: 24px;
  position: absolute;
  transition: 0.4s;
  z-index: 2;
}
.upload-container .upload--section {
  width: 100%;
  text-align: left;
  position: absolute;
  left: 0;
  line-height: 76px;
  padding-left: 100px;
  transition: 0.4s;
  z-index: 0;
}
.upload-container input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.upload-container:hover {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
.upload-container:hover .upload--btn {
  background-color: #2e93a1;
  color: #fff;
  transition: 0.4s;
  z-index: 2;
}
.upload-container:hover .upload--section {
  background-color: #fafafc;
  color: #2e93a1;
  transition: 0.4s;
  z-index: 0;
}
.upload-container:focus {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
#b2bfd0 ::placeholder {
  color: red !important;
}
:-ms-input-placeholder {
  color: red !important;
}
::-ms-input-placeholder {
  color: red !important;
}
.genderBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.genderBtn .genderRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.genderBtn .genderText {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.genderBtn > input[type=radio]:checked + .genderText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  z-index: 2;
}
.wc-checkbox {
  width: 20px !important;
  height: 20px !important;
  position: relative;
  left: 0;
  top: 0;
  cursor: pointer;
}
.wc-checkbox input[type=checkbox] {
  left: 0;
  right: 0;
  width: 20px;
  height: 20px;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
}
.wc-radioBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.wc-radioBtn .teamRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.wc-radioBtn .teamText {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.wc-radioBtn > input[type=radio]:checked + .teamText,
.wc-radioBtn > input[type=checkbox]:checked + .teamText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  cursor: pointer;
}
.wc-ghostBtn {
  padding: 7px 21px;
  border: 1px solid #969696;
  background-color: #fff;
  color: #484b59;
  transition: 0.5s;
  outline: none;
  border-radius: 3px;
}
.wc-ghostBtn:hover {
}
.wc-ghostBtn:focus {
  color: #2e93a1;
  background-color: #fff;
}
.wc-ghostdisabled {
  color: #999999;
  border: 2px solid #999999;
  background-color: #fff;
  outline: none;
}
.wc-ghostBtnRed {
  border: 2px solid #DE0000;
  background-color: #fff;
  color: #DE0000;
  transition: 0.5s;
  outline: none;
}
.wc-ghostBtnRed:hover {
  color: #fff;
  background-color: #DE0000;
}
.wc-ghostBtnRed:focus {
  color: #fff;
  background-color: #DE0000;
}
@media only screen and (max-width: 1440px) {
  .wc-checkbox {
    width: 25px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1368px) {
  .wc-checkbox {
    width: 30px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1170px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media (max-width: 768px) {
  .modal-dialog {
    max-width: 700px;
    margin: 1.75rem auto;
  }
}
@media (max-width: 576px) {
  .modal-dialog {
    max-width: 95%;
    margin: 1.75rem auto;
  }
}
@media only screen and (max-width: 768px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 576px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
.ats-upload-btn {
  width: 100%;
  border: dashed 0.5px #b0bed2;
  color: #484b59;
  display: flex;
  box-sizing: border-box;
  position: relative;
}
.ats-upload-btn span {
  color: #d1d1d1;
  font-size: 34px;
  line-height: 1;
  z-index: 0;
}
.ats-upload-btn .ats--upload-cv,
.ats-upload-btn .ats--upload-linkedin {
  width: 50%;
  float: left;
  padding: 20px;
  border-right: 1px dashed #b0bed2;
  box-sizing: border-box;
  z-index: 0;
}
.ats-upload-btn .ats--upload-linkedin {
  border-right: none;
}
.ats-upload-btn input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.social-check {
  position: relative;
  cursor: pointer;
  margin-right: 10px;
}
.social-check input[type=checkbox] {
  width: 15px;
  height: 15px;
  opacity: 0;
}
.social-check i {
  font-size: 14px;
  position: absolute;
  left: 0;
  top: 0;
  color: #b2bfd0;
  cursor: pointer;
  transition: 0.5s;
}
.social-check input[type=checkbox]:checked + i {
  transition: 0.5s;
  color: #2e93a1;
}
input[type=month]::-webkit-inner-spin-button {
  display: none;
}
input[type=month]::-webkit-calendar-picker-indicator {
  opacity: 0;
  z-index: 2;
}
div.uploadFile {
  position: relative;
}
div.uploadFile input[type=file] {
  width: 100%;
  padding: 6px 12px;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  z-index: 2;
}
div.uploadFile span {
  position: absolute;
  left: 12px;
  top: 7px;
  z-index: 0;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 93%;
  white-space: nowrap;
}
div.uploadFile span i {
  color: #b2bfd0;
  cursor: pointer;
}
.custom-control-label::before {
  background-color: #fff;
  border: #2e93a1 solid 1px;
}
.custom-control-label::after {
  background-color: #2e93a1;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #2e93a1;
  background-color: #2e93a1;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  -webkit-transform: translateX(0.75rem);
  transform: translateX(0.75rem);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #2e93a1;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(48, 5, 127, 0.4);
}
.wc-can-cta .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
}
@media (max-width: 576px) {
  .ats-upload-btn {
    width: 100%;
    height: 100%;
    border: dashed 0.5px #b0bed2;
    color: #484b59;
    display: block;
    box-sizing: border-box;
    position: relative;
  }
  .ats-upload-btn span {
    color: #d1d1d1;
    font-size: 50px;
    line-height: 1;
    z-index: 0;
  }
  .ats-upload-btn .ats--upload-cv,
  .ats-upload-btn .ats--upload-linkedin {
    width: 100%;
    float: left;
    padding: 40px;
    border-right: 1px dashed #b0bed2;
    box-sizing: border-box;
    z-index: 0;
    display: block;
    border-bottom: 1px dashed #b0bed2;
  }
  .ats-upload-btn .ats--upload-linkedin {
    border-right: none;
    border-bottom: none;
  }
  .ats-upload-btn input {
    position: absolute;
    height: 100%;
    width: 100%;
    outline: none;
    cursor: pointer;
    opacity: 0;
    display: block;
  }
}
.bg-banner {
  background: url("./media/bg-image-ZQ6KMGTV.png");
  background-position: left top;
  background-size: cover;
  height: 100%;
}
.bg-banner .blueOverlay {
  position: absolute;
  opacity: 0.9;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 333;
  height: 100%;
}
.py-40 {
  padding-top: 45px;
}
.centeredForm {
  margin-top: 80px;
}
.logowidth {
  width: 45px;
  height: auto;
}
.wc-logotext {
  font-size: 30px;
  color: #fff;
}
.text-fafafa {
  color: #fafafa;
}
.iconDiv {
  width: 45px;
  float: left;
}
.textDiv {
  width: calc(100% - 45px);
  float: left;
}
.overlay {
  width: 100%;
  height: 80%;
  background-image:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgb(34, 53, 78));
  position: absolute;
  bottom: 0%;
}
.h100vh {
  height: 100vh;
}
#loginContainer {
  position: fixed;
  top: 0;
  left: 0;
}
@media only screen and (max-width: 600px) {
  .h100vh {
    height: 135vh;
  }
}
.logowidth {
  width: 35px;
  height: auto;
}
.wc-logotext {
  font-size: 22px;
  color: #FF9B05;
  vertical-align: -webkit-baseline-middle;
  line-height: 1;
  font-weight: 600;
}
.nav-pills .nav-link {
  border-radius: 3px;
  background-color: #F5F6F9;
}
.nav-link {
  display: block;
  padding: 0.5rem 2.5rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  font-weight: bold;
  background-color: #2e93a1;
}
.test {
  position: relative;
}
.test input[type=text] {
  background-color: transparent;
  z-index: 1;
}
.test .droparrow-down,
.test .droparrow-up {
  position: absolute;
  top: 9px;
  right: 15px;
  color: #d6dde6;
}
.test .fa-chevron-up {
  display: none;
}
input[type=text]:focus + .droparrow-down .fa-chevron-down {
  display: none;
  color: #2e93a1;
}
input[type=text]:focus + .droparrow-down .fa-chevron-up {
  display: block;
  color: #2e93a1;
}
.progress-c {
  width: 100px;
  height: 100px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
  border: 5px solid #fff;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2e93a1;
  font-weight: bold;
}
.wc-linked-btn-1,
.wc-uplaodrsume-btn-1 {
  width: 45%;
  float: left;
  color: #008bc2;
  border: 2px solid #008bc2;
  border-radius: 2px;
  margin-left: 15px;
  cursor: pointer;
}
.wc-linked-btn-1 .wc-linked-btn-i,
.wc-linked-btn-1 .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1 .wc-linked-btn-i,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  padding: 8px 9px;
  display: inline-flex;
  border-right: 2px solid #008bc2;
  justify-content: center;
}
.wc-linked-btn-1 .wc-linked-btn-t,
.wc-linked-btn-1 .wc-uplaodrsume-btn-t,
.wc-uplaodrsume-btn-1 .wc-linked-btn-t,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-t {
  padding: 3px 10px;
  display: inline-flex;
  justify-content: center;
  width: calc(100% - 36px);
}
.wc-linked-btn-1:hover,
.wc-uplaodrsume-btn-1:hover {
  color: #ffffff;
  background: #008bc2;
  border: 2px solid transparent;
  transition: 0.5s;
}
.wc-linked-btn-1:hover .wc-linked-btn-i,
.wc-linked-btn-1:hover .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-linked-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-uplaodrsume-btn-i {
  border-right: 2px solid #fff;
  padding: 8px 9px;
}
.wc-uplaodrsume-btn-1 {
  position: relative;
  color: #84DA28;
  border: 2px solid #84DA28;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  border-right: 2px solid #84DA28;
}
.wc-uplaodrsume-btn-1 .resumeuplad {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .resumeuplad input[type=file] {
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1:hover {
  background: #84DA28;
}
button.close {
  outline: none;
}
input.wc-form-control:focus {
  z-index: 2;
}
.test input[type=text]:focus {
  z-index: 2;
}
.bg-input {
  width: 85%;
  color: #484b59;
  background-color: #eaeaea !important;
  border: 1px solid #ecf0f4;
  border-radius: 2px;
  padding: 10px;
}
@media screen and (max-width: 1920px) {
  .bg-input {
    width: 90%;
  }
}
@media screen and (max-width: 1680px) {
  .bg-input {
    width: 89%;
  }
}
@media screen and (max-width: 1440px) {
  .bg-input {
    width: 87%;
  }
}
@media screen and (max-width: 1366px) {
  .bg-input {
    width: 86%;
  }
}
@media screen and (max-width: 1280px) {
  .bg-input {
    width: 84%;
  }
}
@media screen and (max-width: 1024px) {
  .bg-input {
    width: 83%;
  }
}
.bq-div {
  width: calc(100% - 200px);
}
.w-200px {
  width: 200px;
  display: flex;
  align-items: center;
}
.copy-btn {
  padding: 10px 20px;
  position: absolute;
  left: 0;
  top: -21px;
}
.btn-position {
  position: absolute;
  right: -10px;
  width: 95px;
}
.boolean-input {
  overflow: hidden;
  line-height: 1.3;
  resize: none;
}
.copy-btn-search {
  padding: 7px;
  width: 90px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #ecf0f4;
  border-left: none;
}
.sticky-box {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  margin-bottom: 15px;
}
.w-100px {
  width: 130px;
}
.circular-img {
  width: 59px;
  height: 59px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 600;
}
.rightsideclose.mat-chip.mat-standard-chip {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-direction: row-reverse;
}
.isActive {
  color: #2e93a1 !important;
}
.card {
  border-left: none;
  border-right: none;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.card-header {
  padding: 0.5rem 0;
  margin-bottom: 0;
  background-color: hsla(0, 0%, 100%, 0.03);
  border-bottom: none;
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
.collapse:not(.show) {
  display: none;
}
.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
.btn-link {
  font-weight: 400;
  text-decoration: none;
  color: #484b59;
}
.btn-link .wcAccordianUpDownArrow .test1 {
  display: block;
  transition: display 0.4s;
}
.btn-link .wcAccordianUpDownArrow .test2 {
  display: none;
  transition: display 0.4s;
}
.btn-link .collapsed + .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.btn-link .collapsed + .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.btn-link .collapsed .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.btn-link .collapsed .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.collapsed {
  color: #484b59;
}
.collapsed + .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.collapsed + .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.collapsed .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
.collapsed .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.wcAccordianUpDownArrow {
  right: 0;
  justify-self: flex-end;
}
.underline-on-hover:hover {
  text-decoration: underline;
  cursor: pointer;
}
.show-on-hover {
  display: none;
}
.hoverable-element:hover .show-on-hover {
  display: block;
}
.add-to-talentpool {
  padding-top: 7px;
  padding-bottom: 7px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 4px;
  border: solid 0.5px #2e93a1;
  background-color: #ffffff;
  padding: 6px 12px;
  height: 35px;
}
.reset-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  background-color: #969696;
  color: #fff;
}
.static ~ .toggle .up {
  display: block;
}
.static ~ .toggle .down {
  display: none;
}
.static.collapsed ~ .toggle .up {
  display: none;
}
.static.collapsed ~ .toggle .down {
  display: block;
}
.empty-state-img {
  width: 138.92px;
  height: 177.81px;
}
.new-form {
  width: 125px;
  height: 25px;
  padding: 1px 6px 2px 4px;
  border-radius: 4px;
  border: solid 1px #d5dee6;
  background-color: #fff;
}
.wc-form-control:focus {
  border-color: #2E93A1;
  outline: none;
}
.new-form:focus {
  border-color: #2E93A1;
  outline: none;
}
.f-13 {
  font-size: 13px;
  line-height: 1.3;
}
.mat-chip.mat-standard-chip .mat-chip-remove {
  color: rgba(0, 0, 0, 0.87);
  opacity: inherit !important;
}
.excluded-chip {
  background-color: #fae7e7 !important;
}
#overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 6;
  top: 0;
  left: 0px;
  background-color: #000;
  opacity: 0.4;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 30px;
  display: none;
}
#quickView {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 6;
  top: 0;
  right: -60px;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 0px 0px;
}
.male-box {
  height: 8px;
  flex-grow: 0;
}
ul {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.lavender-circle {
  background-color: #E1D8E9 !important;
  color: #725190 !important;
}
.yellow-circle {
  background-color: #FFF9D7 !important;
  color: #E0BF00 !important;
}
.blue-circle {
  background-color: #B9D4F4;
  color: #1C5FB0;
}
.pink-circle {
  background-color: #FBDAE7;
  color: #A5124D;
}
.teal-circle {
  color: #34A853;
  background-color: #EBF6EE;
}
::ng-deep .mat-table {
  font-family: "Poppins", sans-serif !important;
}
.skills-chip {
  background-color: #e4f1f3;
  border-radius: 16px;
  min-height: 26px;
  font-weight: 500;
  font-size: 12px;
}
.hoverToShowGuideline {
  cursor: pointer;
}
.hoverToShowGuideline:hover i {
  color: #2e93a1;
}
.hoverToShowGuideline:hover .searchGuide {
  width: calc(100% - 125px);
  display: block;
  transition: display 0.5s;
}
.hoverToShowGuideline:hover .searchResutlBackdrop {
  display: block;
}
.searchGuide {
  width: 100%;
  background-color: white;
  display: none;
  transition: display 0.5s;
  position: fixed;
  top: 70px;
  left: 95px;
  padding: 20px;
  z-index: 4;
  text-align: left;
}
.hoverable-class:hover {
  cursor: pointer;
}
.red-dot {
  color: #CD0F0F;
  font-size: 28px;
  line-height: 1;
}
.loader {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader img {
  width: 60px;
}
.loader.small {
  height: 200px;
}
.loader.medium {
  height: 365px;
}
.loader.big {
  height: 400px;
}
#top2,
#viewless2,
#top4,
#viewless4 {
  display: none;
}
.ml-8 {
  margin-left: 35px;
}
.save-search-btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border: solid 0.5px #2E93A1;
  background-color: #fff;
  padding: 8px 20px;
  white-space: nowrap;
  border-radius: 3px;
}
.newCompCard {
  border-radius: 2px;
  background-color: #fff;
  padding: 15px 15px;
  height: 100%;
}
.newCompCard img {
  width: 70px;
  height: 70px;
}
.compLogoIcon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e4f1f3;
  margin-right: 15px;
  font-size: 20px;
  overflow: hidden;
}
.compLogoIcon img {
  width: 100%;
  height: auto;
}
.dstooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.dstooltip-content {
  display: none;
  position: absolute;
  min-width: 360px;
  width: 360px;
  box-shadow: 0 4px 10px 0 rgba(46, 147, 161, 0.2);
  top: 18px;
  z-index: 1;
}
.dstooltip:hover .dstooltip-content {
  display: block;
}
.dropup:hover .dropbtn {
  background-color: #2980B9;
}
.chipsnew {
  background-color: #e4f1f3;
  border-radius: 18px;
  font-size: 12px;
  font-weight: 500;
  padding: 3px 6px;
  max-width: 150px;
  width: 150px;
  margin-bottom: 5px;
}
.disabled {
  background-color: gray;
  cursor: default;
}
.containerheight {
  height: 88vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.filterScrollFix {
  height: 97vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: sticky;
  top: 0;
  z-index: 1;
}
.sticky-box {
  position: relative;
  width: 100%;
  height: 42vh;
  overflow-y: scroll;
  margin-bottom: 15px;
}
.filterScrollFix::-webkit-scrollbar {
  width: 4px;
}
.filterScrollFix:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
.filterScrollFix::-webkit-scrollbar-track {
  background: white !important;
}
.filterScrollFix::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
.filterScrollFix::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.talentCountFixonScroll {
  position: sticky;
  top: 0px;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.onscrollStickTop {
  position: sticky;
  top: 0;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.ats-dropBtn .dropdown-menu {
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
}
.ats-dropBtn .dropdown-menu a.dropdown-item:hover {
  color: #969696;
  background-color: #EBF0F4;
}
.btn-break {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.card-data {
  height: 130px;
}
.dropdown-toggle::after {
  border-top: none;
}
.four-matrix {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
  padding: 5px 18px;
  cursor: pointer;
}
.four-matrix p {
  color: #969696;
}
.four-matrix:hover {
  background-color: #f2f2f2;
}
.four-matrix:hover p {
  color: var(--Primary-Text);
}
.changedJobs {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
}
.changedJobs-matrix {
  width: 100%;
  padding: 5px 18px;
  cursor: pointer;
}
.changedJobs-matrix p {
  color: #969696;
}
.changedJobs-matrix:hover {
  background-color: #f2f2f2;
}
.changedJobs-matrix:hover p {
  color: var(--Primary-Text);
}
.selectInMatrix {
  font-size: 12px;
  padding: 5px 18px;
  width: 100%;
  border: none;
  color: #969696;
  border-radius: 4px;
}
.diversity-matrix {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
  cursor: pointer;
}
.gender-ratio {
  width: 50%;
  padding-top: 8px;
  padding-bottom: 2px;
  cursor: pointer;
}
.gender-ratio p {
  color: #969696;
}
.gender-ratio:hover {
  background-color: #f2f2f2;
}
.gender-ratio:hover p {
  color: var(--Primary-Text);
}
.gender {
  text-align: center;
}
.redirect-report {
  background-image: url(/assets/redirect-bg.png);
}
.redirect-filter {
  padding: 4px 12px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  border: solid 1px #d9d9d9;
}
.redirect-filter-others {
  color: #484b59;
  font-size: 14px;
}
.redirect-dot {
  width: 4px;
  height: 4px;
  flex-grow: 0;
  background-color: #969696;
}
.headerbg {
  background-color: #fff;
  background-image: url("./media/headerbg-YKGJQXIS.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top;
  height: 100%;
  border-radius: 4px;
}
.similar-candidate-chip {
  border-radius: 30px;
  border: 1px solid var(--Box-Border, #D9D9D9);
  background: #FFF;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: 400;
}
.containerheight {
  height: 88vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.filterScrollFix {
  height: 97vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: sticky;
  top: 0;
  z-index: 1;
}
.sticky-box {
  position: relative;
  width: 100%;
  height: 42vh;
  overflow-y: scroll;
  margin-bottom: 15px;
}
.filterScrollFix::-webkit-scrollbar {
  width: 4px;
}
.filterScrollFix:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
.filterScrollFix::-webkit-scrollbar-track {
  background: white !important;
}
.filterScrollFix::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
.filterScrollFix::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.talentCountFixonScroll {
  position: sticky;
  top: 0px;
  z-index: 1;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.onscrollStickTop {
  position: sticky;
  top: 0;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
.ats-dropBtn .dropdown-menu {
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
}
.ats-dropBtn .dropdown-menu a.dropdown-item:hover {
  color: #969696;
  background-color: #EBF0F4;
}
.btn-break {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.card-data {
  height: 130px;
}
.dropdown-toggle::after {
  border-top: none;
}
.four-matrix {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
  padding: 5px 18px 8px 18px;
  cursor: pointer;
}
.four-matrix p {
  color: #969696;
}
.four-matrix:hover {
  background-color: #f2f2f2;
}
.four-matrix:hover p {
  color: var(--Primary-Text);
}
.diversity-matrix {
  border-radius: 4px;
  width: 100%;
  border: solid 1px #d9d9d9;
  margin: 0 4px;
  cursor: pointer;
}
.gender-ratio {
  width: 50%;
  padding-top: 8px;
  padding-bottom: 2px;
  cursor: pointer;
}
.gender-ratio p {
  color: #969696;
}
.gender-ratio:hover {
  background-color: #f2f2f2;
}
.gender-ratio:hover p {
  color: var(--Primary-Text);
}
.gender {
  text-align: center;
}
.redirect-report {
  background-image: url(/assets/redirect-bg.png);
}
.redirect-filter {
  padding: 4px 12px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  border: solid 1px #d9d9d9;
}
.redirect-filter-others {
  color: #484b59;
  font-size: 14px;
}
.redirect-dot {
  width: 4px;
  height: 4px;
  flex-grow: 0;
  background-color: #969696;
}
.headerbg {
  background-color: #fff;
  background-image: url("./media/headerbg-YKGJQXIS.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top;
  height: 100%;
  border-radius: 4px;
}
.similar-candidate-chip {
  border-radius: 30px;
  border: 1px solid var(--Box-Border, #D9D9D9);
  background: #FFF;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: 400;
}
.card-img {
  width: 120px;
  height: 100%;
  margin: 50.9px 60px 11px 3px;
  object-fit: contain;
}
.item {
  width: 190px;
  height: 60px;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn .dropdown-toggle::after {
  border-top: none;
  outline: none;
}
.ats-dropBtn .dropdown-menu.show {
  border: none;
  transform: translate3d(-44px, 26px, 0px) !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
  padding: 0;
  width: fit-content;
  padding: 18px;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #fff;
}
.ats-dropBtn.slider-drop .dropdown-menu.show {
  transform: translate3d(-213px, 26px, 0px) !important;
  padding: 8px 0 !important;
}
.region-box {
  width: 160px;
  height: 90px;
  border-radius: 4px;
  overflow: hidden;
}
.border-blue {
  border: 2px solid #2e93a1;
}
.border-gray {
  border: 1px solid #cacaca;
}
.spinner-border {
  width: 1rem;
  height: 1rem;
  z-index: 3;
}
.logobgcolor {
  background-color: rgba(48, 5, 127, 0.04);
}
.dumy-placeholder {
  position: absolute;
  bottom: 20px;
  left: 20px;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: #8a8682;
  z-index: 0;
  line-height: 1.3;
}
.default-placeholder {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: #8a8682;
  line-height: 1.3;
}
.filters-tooltip-content {
  display: none;
  position: absolute;
  bottom: 1.875rem;
  right: 0;
  background-color: #fff;
  text-wrap: nowrap;
  width: fit-content;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  z-index: 5;
  padding: 0.5rem 0;
}
.dstooltip:hover .filters-tooltip-content {
  display: block;
}
.filters-tooltip-content div {
  position: relative;
  margin-left: -5px;
}
.hiderule:last-child > hr {
  display: none;
}
.dot {
  width: 4px;
  height: 4px;
  background-color: #484b59;
  border-radius: 50%;
  position: absolute;
  left: 19px;
  top: 8px;
}
.hl-mssg {
  margin: 0 1rem;
  margin-left: 1.5rem;
  display: inline-block;
  padding: 0 8px;
  line-height: 1.5;
}
.ai-text-gradient {
  background-image:
    linear-gradient(
      251deg,
      #c845ab 85%,
      #e24e7f 48%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.sim-can-edit-btn {
  width: 74px;
  height: 29px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 4px 12px;
  border-radius: 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
  color: #484b59;
}
.sim-can-edit-btn:focus {
  outline: none;
}
::-webkit-scrollbar {
  width: 4px;
}
:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
::-webkit-scrollbar-track {
  background: white !important;
}
::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.ai-suggestions-header {
  height: 25px;
  flex-grow: 0;
  background-image: url("./media/gradient-Q42PCSKJ.png");
  position: relative;
  background-repeat: no-repeat;
  background-size: 200px 50px;
}
.gtext {
  position: absolute;
  color: #100f0f;
  position: absolute;
}
.suggestion-chips {
  max-width: 200px;
  height: 30px;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 18px;
  border: solid 1px #969696;
  background-color: #fff;
}
.isSelected {
  border: solid 1px #2e93a1;
  color: #2e93a1;
}
.disable-btn {
  cursor: not-allowed;
  background-color: #f2f2f2;
  color: #969696;
}
.enable-btn {
  cursor: pointer;
  background-color: #e4f1f3;
  color: #2e93a1;
  border: solid 1px #2e93a1;
}
.ai-container-box {
  border-style: solid;
  border-width: 1px;
  border-image-source:
    linear-gradient(
      250deg,
      #c845ab 85%,
      #e24e7f 48%);
  border-image-slice: 1;
}
.page-selection {
  color: #484b59;
  position: absolute;
  right: 0;
  margin-right: 30px;
}
.page-selection select {
  gap: 4px;
  margin: 0 7px 0 6px;
  padding: 4px 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
}
.sticky-pagination {
  position: sticky;
  bottom: 0;
}
.chip-container {
  max-height: 60px;
  overflow: hidden;
}
.chip-container.expanded {
  max-height: none;
}
.listContainer {
  width: 100%;
}
.listContainer .listHeader {
  width: 100%;
  float: left;
  background-color: #fafafc;
  padding: 10px;
  z-index: 1;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.listContainer .listHeader .listHeader-col {
  width: 26%;
  float: left;
}
.listContainer .listHeader .listHeader-col:first-child {
  width: 50px;
}
.listContainer .listHeader .listHeader-col:last-child {
  width: 150px;
}
.listContainer .listHeader .listHeader-col:nth-last-child(2) {
  width: 150px;
}
.listContainer .listBody {
  width: 100%;
  float: left;
  padding: 10px;
  z-index: 1;
  border-bottom: 1px solid #fafbfc;
  cursor: pointer;
}
.listContainer .listBody .listBody-col {
  width: 26%;
  float: left;
}
.listContainer .listBody .listBody-col:first-child {
  width: 50px;
}
.listContainer .listBody .listBody-col:last-child {
  width: 150px;
}
.listContainer .listBody .listBody-col:nth-last-child(2) {
  width: 150px;
}
.listContainer .listBody .listBody-col .list-cta-group {
  display: none;
  transition: display 0.4s ease-in-out;
  position: absolute;
}
.listContainer .listBody:hover .listBody-col .list-cta-group {
  display: block;
  transition: display 0.4s ease-in-out;
}
.wc-dropdwon-box.show {
  display: block;
  position: absolute !important;
  left: -67px !important;
  top: 5px !important;
  background-color: #fff;
  border: none;
  width: 300px;
}
.wc-dropdwon-box.show .prajDropValue {
  padding: 6px 15px;
}
.wc-dropdwon-box.show .prajDropValue:hover {
  background-color: #fafbfc;
}
.ats-cta-btn i.wc-fa-notify {
  color: red;
  font-size: 6px !important;
  position: absolute;
  top: 0;
  right: 0;
}
.overflow-text {
  font-size: 12px;
}
.overflow-text .overflow-msg-box {
  padding: 20px;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17), 0 -1px 4px 0 rgba(0, 0, 0, 0.16);
  display: none;
  transition: display 4s ease-in-out !important;
  position: absolute;
  width: 70%;
  height: auto;
  top: 69px;
  background: #fff;
  z-index: 1;
}
.overflow-text:hover .overflow-msg-box {
  display: block;
  transition: display 4s ease-in-out !important;
}
.oncardlistHover:hover {
  box-shadow: 0 0 12px 2px rgba(221, 221, 221, 0.5);
  z-index: 1;
}
.selectTalentpool {
  border-radius: 2px;
  background-color: #ffffff;
  border: solid 1px #979797;
}
.addtotalentpool {
  overflow: auto;
  height: 317px;
}
.temp {
  width: 175px;
  padding: 15px;
  border-radius: 2px;
  box-shadow: 3px 1px 10px 0 rgba(172, 172, 172, 0.9);
  background-color: #ffffff;
  text-align: right;
  z-index: 2;
}
.dropdown-toggle::after {
  display: none;
}
span.dropdown-menu.show {
  position: absolute;
  left: -50px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.17);
  border: none;
  top: 8px !important;
}
.ats-dropBtn .dropdown-menu.show {
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
  padding: 0;
  width: fit-content;
  padding: 8px !important;
  left: -158px !important;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #fff;
}
::ng-deep .tooltip-inner {
  width: 100%;
  background-color: #fff3e0;
  color: #2C2C2C;
}
.justify-content-between div.testp {
  overflow: hidden;
  width: calc(100% - 120px);
}
.scrolltalentpool {
  height: 100px;
  overflow-y: auto;
}
.onhverNotesEllipsis {
  display: none;
}
.oncardlistHover:hover .onhverNotesEllipsis {
  display: block;
}
em {
  background-color: #FCE3A1;
  font-style: normal;
  padding: 2px 4px;
}
.ats-cta-btn-new {
  width: 24px;
  height: 24px;
  padding: 5px 7px;
  border-radius: 2px;
  background-color: rgba(103, 198, 187, 0.2);
}
.ats-cta-btn-new i {
  color: #67c6bb;
  font-size: 17px;
  font-weight: 600;
  margin-left: 0px;
  position: relative;
  right: -1px;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 1px solid #67c6bb;
  border-radius: 1px;
  position: absolute;
  left: 0;
  top: 0;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-transition: 0.5s;
  transition: 0.5s;
}
.bg-gray {
  background-color: #f4f4f4 !important;
}
.w26px {
  width: 26px;
}
.w-auto {
  width: auto;
}
.search-btn {
  color: #FFD200;
  background-color: #FFF6CC;
  width: 24px;
  height: 24px;
  padding: 5px 7px;
  cursor: pointer;
}
.search-btn-inactive {
  color: #2c2c2c !important;
  background-color: #cccccc !important;
  opacity: 0.3 !important;
  pointer-events: none !important;
}
.circleCount {
  height: 18px;
  width: 18px;
  border-radius: 20px;
  background-color: #AF2C2C;
  color: white;
  position: absolute;
  left: 20px;
  top: 20px;
  right: 0;
  text-align: center;
}
.trx {
  padding-right: 10px;
}
.tr0 {
  right: 10px;
  top: 25px;
}
.hot-dot {
  width: 12px;
  height: 12px;
  background-color: #4ac98e;
  border-radius: 50%;
  display: inline-block;
}
.warm-dot {
  width: 12px;
  height: 12px;
  background-color: #ffd200;
  border-radius: 50%;
  display: inline-block;
}
.cold-dot {
  width: 12px;
  height: 12px;
  background-color: #777777;
  border-radius: 50%;
  display: inline-block;
}
.boxed-candidatecount {
  width: 150px;
  height: 35px;
  border: solid 1px #cccccc;
  border-right: none;
  padding: 5px;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
}
.boxed-candidatecount:last-child {
  border-right: solid 1px #cccccc;
}
.boxed-candidatecount-active {
  border: solid 1px #2e93a1 !important;
  background-color: #2e93a1 !important;
  color: white !important;
  text-align: center;
}
.boxed-candidatecount-active-hot {
  border: solid 1px #18B06A !important;
  background-color: #18B06A !important;
  color: white !important;
  text-align: center;
}
.boxed-candidatecount-active-warm {
  border: solid 1px #FFD200 !important;
  background-color: #FFD200 !important;
  color: white !important;
  text-align: center;
}
.boxed-candidatecount-active-cold {
  border: solid 1px #777777 !important;
  background-color: #777777 !important;
  color: white !important;
  text-align: center;
}
a.dropdown-toggle.gray-text:hover {
  color: #206C79;
}
.m-left--1 {
  margin-left: -1px;
}
.pos-abs-top-left {
  left: -65px;
  top: -15px;
}
.wccard {
  border-radius: 2px;
  background-color: #ffffff;
  border: 1px solid #f9f9f9;
  box-shadow: 0 1px 1px 0 rgba(201, 200, 200, 0.5);
}
.wc-ats-chip {
  padding: 5px 15px;
  background-color: #fafbfc;
  font-size: 12px;
  border-radius: 16px;
}
.wc-ats-chip span i {
  font-size: 12px;
  color: #484b59;
}
.isActive {
  color: #2e93a1 !important;
}
.ats-dropBtn .dropdown-menu {
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
}
.ats-dropBtn .dropdown-menu a.dropdown-item:hover {
  color: #969696;
  background-color: #EBF0F4;
}
.btn-break {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.trms-info-panel {
  background-color: #f4fbff;
  border: 1px solid #d2eefc;
  color: #0f5566;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.2;
}
.trms-info-panel i {
  margin-right: 8px;
  margin-top: 3px;
  color: #2e93a1;
  font-size: 14px;
  align-self: flex-start;
}
.dropdown-toggle::after {
  border-top: none;
}
.circular-img {
  width: 59px;
  height: 59px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 600;
}
.canProfilePic {
  width: 60px;
  height: 60px;
  background-color: rgba(48, 5, 127, 0.04);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 24px;
  overflow: hidden;
  border-radius: 100px;
}
.canProfilePic:hover .onHoverPicChange {
  visibility: visible;
  opacity: 1;
  transition: all 0.5s;
}
.canProfilePic .onHoverPicChange {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.25);
  color: white;
  position: absolute;
  visibility: hidden;
  opacity: 0;
  transition: all 0.5s;
}
.canProfilePic img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
  border-radius: 4px;
}
.canProfilePic img:hover + .onHoverPicChange {
  visibility: visible;
  opacity: 1;
  transition: all 0.5s;
}
.canProfilePic i {
  font-size: 40px;
}
.tag-btn {
  width: 24px;
  height: 24px;
  background-color: rgba(46, 161, 120, 0.1);
  padding: 2px 2px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 100px;
  color: #2dc3a5;
  font-size: 12px;
}
.fltr-btn {
  border: 1px solid #2e93a1;
  padding: 5px 21px;
  color: #2e93a1;
  border-radius: 2px;
}
.p-none {
  pointer-events: none !important;
}
.disabled-social {
  background-color: #969696 !important;
  color: #fff !important;
  pointer-events: none;
}
.reveal-cand {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: #2e93a1;
  padding: 5px 10px;
  border-radius: 4px;
  border: solid 1px #2e93a1;
  background-color: #E4F1F3;
  font-size: 14px;
}
.reveal-cand-disable {
  color: #fff;
  border: solid 1px #969696;
  background-color: #b9afaf;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #206C79;
  border: none;
  transition: 0.5s;
  font-size: 10px;
}
.wc-checkbox input[type=checkbox] {
  width: 11px;
  height: 12px;
}
.wc-checkbox {
  width: 15px !important;
  height: 15px !important;
}
.revealbtn {
  padding: 2px 8px;
  border-radius: 2px;
  background-color: #229300;
  color: #ffffff;
  font-size: 12px;
}
.emptyScreen {
  width: 100%;
  height: 760px;
  background-color: #fff;
  background-image: url("./media/backgroundvetor-1-UWXZZ6O6.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left bottom;
}
.createFirstTalenpool {
  height: 65%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.talent-btn {
  padding: 7px 21px;
  color: #ffffff;
  font-weight: 100;
  border-radius: 3px;
  outline: none;
  border: none;
  cursor: pointer;
  align-items: center;
  right: 30px;
}
.textBox {
  height: 39px;
  overflow: hidden;
}
.viewMore {
  overflow: visible;
  height: auto;
}
.textBox.viewMore {
  overflow: visible;
  height: auto;
}
a.dropdown-item {
  padding: 7px 7px;
}
.wc-ghostBtn {
  border: 1px solid #d5dee6;
}
.dstooltip {
  position: relative;
  display: inline-block;
}
.dstooltip-content {
  display: none;
  position: absolute;
  min-width: 360px;
  width: 360px;
  box-shadow: 0 4px 10px 0 rgba(46, 147, 161, 0.2);
  top: 18px;
  z-index: 1;
}
.dstooltip:hover .dstooltip-content {
  display: block;
}
.dropup:hover .dropbtn {
  background-color: #2980B9;
}
.chipsnew {
  background-color: #e4f1f3;
  border-radius: 18px;
  font-size: 12px;
  font-weight: 500;
  padding: 3px 6px;
  max-width: 150px;
  width: auto;
  margin-bottom: 5px;
}
.companyHover {
  text-decoration: underline;
  text-decoration-style: dashed;
  text-decoration-color: #969696;
}
.disabled {
  background-color: gray;
  cursor: default;
}
#bulk-process {
  margin-top: 12px;
  margin-bottom: 12px;
  border-radius: 4px;
  background-color: #e6fcff;
  padding: 8px 0px 8px 0px;
}
.bulk-process-text {
  font-size: 14px;
  color: #484b59;
  margin: 8px;
}
#bulk-talentpool-level {
  font-size: 14px;
  font-weight: 500;
  margin-top: 8px;
  margin-bottom: 8px;
  border-radius: 4px;
  background-color: #fff8e7;
  padding: 20px 0px 20px 16px;
}
.process-env {
  padding: 7px 12px 8px 12px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  font-size: 14px;
  background-color: #2e93a1;
  color: #ffffff;
}
.loader {
  width: 100%;
  height: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader img {
  width: 60px;
}
.loader.small {
  height: 200px;
}
.loader.medium {
  height: 365px;
}
.loader.big {
  height: 400px;
}
.customeRadioBtn {
  display: block;
  position: relative;
  padding-left: 20px;
  margin-bottom: 0px;
  cursor: pointer;
  font-size: 14px;
  margin-right: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.customeRadioBtn input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  left: 0;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #fff;
  border-radius: 50%;
  border: 2px solid #2e93a1;
  margin-top: 2px;
}
.customeRadioBtn input:checked ~ .checkmark {
  border: 2px solid #2e93a1;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.customeRadioBtn input:checked ~ .checkmark:after {
  display: block;
}
.customeRadioBtn .checkmark:after {
  top: 2px;
  left: 2px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2e93a1 content-box;
}
.page-selection {
  color: #484b59;
  position: absolute;
  right: 0;
  margin-right: 30px;
}
.page-selection select {
  gap: 4px;
  margin: 0 7px 0 6px;
  padding: 4px 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
}
.ai-text-gradient {
  background-image:
    linear-gradient(
      258deg,
      #c845ab 84%,
      #e24e7f 49%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.similar-candidates-chip-count {
  width: fit-content;
  padding: 0 4px;
  border-radius: 9px;
  background-color: #cd0f0f;
  color: #ffffff;
}
.talenpool-sticky-header {
  position: sticky;
  top: 55px;
  z-index: 1;
}
.sticky-pagination {
  position: sticky;
  bottom: 0;
}
.dropdown-item.active,
.dropdown-item:active {
  text-decoration: none;
  background-color: #EBF5F6 !important;
}
.personsearch-contact-slider {
  color: #484b59;
  margin: 20px;
}
.alert-custom {
  background-color: #e6fcff;
  padding: 0;
  color: #484b59;
  font-size: 14px;
  top: 25px;
}
.alert-custom .toast-div {
  display: flex;
  align-items: center;
  margin: -2px -3px;
}
.alert-custom .toast-div .icon {
  color: #ffffff;
  padding: 18px 11px;
  background-color: #2e93a1;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
.alert-custom .toast-div .toast-text {
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
}
.alert-custom .toast-div .toast-text img {
  width: 21px;
  height: 21px;
}
::ng-deep .alert-dismissible .close {
  display: none !important;
}
.static ~ .toggle .up {
  display: block;
}
.static ~ .toggle .down {
  display: none;
}
.static.collapsed ~ .toggle .up {
  display: none;
}
.static.collapsed ~ .toggle .down {
  display: block;
}
.contact-dropdown {
  border-top: 1px solid #d5dee6;
  border-bottom: 1px solid #d5dee6;
}
.contact-dropdown .dropdown-header {
  padding: 15px 0;
}
.collapse:not(.show) {
  display: none;
}
.radio-expansion-panel-header {
  font-family: Poppins;
  padding: 0;
  margin: 16px 0px 8px;
}
.radio-expansion-panel-header:hover {
  background-color: #fff !important;
}
.radio-expansion-panel-header mat-radio-button {
  padding: 0px 20px;
  pointer-events: none;
}
.radio-expansion-panel {
  box-shadow: none;
  border-radius: 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
  margin: 10px 0px;
}
.contact-icons {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e8ecf1;
  color: #229300;
  font-size: 12px;
  font-weight: normal;
  margin-right: 4px;
}
.expansion-body {
  border-top: 1px solid #d9d9d9;
  padding: 12px 0px;
  font-family: Poppins;
}
.mat-radio-persistent-ripple {
  background-color: none !important;
}
.radio-card {
  font-family: Poppins;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.7;
  letter-spacing: normal;
  text-align: left;
  color: #484b59;
}
textarea {
  margin-top: 12px;
  resize: none;
  width: 100%;
  padding: 12px;
  outline: none;
  border-radius: 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  text-align: left;
}
.webtree-sucess {
  padding: 20px;
  border-radius: 4px;
  background-color: #f2f2f2;
  line-height: 1.7;
}
.noDataFound {
  font-size: 14px;
  padding: 20px;
  border-radius: 4px;
  background-color: #eaf4f6;
  line-height: 1.7;
}
.coin-stack {
  width: 23px;
  height: 23px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #2e93a1;
  color: #ffe500;
  font-size: 12px;
  font-weight: normal;
  margin-right: 4px;
}
.timeSlots {
  padding: 7px 12px;
  color: #484b59;
  font-family: Poppins;
  font-size: 14px;
  border-radius: 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
  outline: none;
}
input[type=time]::-webkit-calendar-picker-indicator {
  background: none;
  display: none;
}
.introdcuction-msg::after {
  content: "*";
  color: red;
}
.addMore {
  visibility: hidden;
  padding: 7px 10px;
  border-radius: 50%;
  color: #2e93a1;
  background-color: #e4f1f3;
  cursor: pointer;
}
.dateTimeForm:last-child .addMore {
  visibility: visible;
}
.popularTag {
  padding: 0 4px;
  border-radius: 2px;
  background-color: #e9ac0d;
  color: #fff8e7;
  margin: 0px 8px;
  font-weight: 600;
}
.addNewContact {
  padding: 8px 16px;
  border-radius: 4px;
  border: solid 1px #2e93a1;
  background-color: #fff;
  color: #2e93a1;
  cursor: pointer;
}
.provider-icon {
  line-height: 2;
  font-weight: 500;
  color: #484b58;
}
.provider-icon img {
  width: 20px;
  margin-right: 5px;
}
.rolling-loader {
  width: 15px;
}
.progress-bar {
}
.progress-bar .mat-progress-bar .mat-progress-bar-buffer {
  background-color: #e4f1f3 !important;
}
.mat-progress-bar .mat-progress-bar-buffer {
  background-color: #e4f1f3 !important;
}
.primary-tag {
  padding: 1px 5px 1px 6px;
  border-radius: 2px;
  background-color: #ffd300;
}
.contact-tag {
  border-radius: 18px;
  background-color: #efeff0;
  padding: 3px 8px;
}
.helpful-tag {
  border-radius: 18px;
  border: solid 0.6px #d5dee6;
  background-color: #fff;
  padding: 1px 9px;
}
.onHoverActions {
  display: none;
}
.onHover:hover .onHoverActions {
  display: inline-block;
}
.coins {
  color: #000;
  font-weight: 500;
}
.manualContactActive {
  margin-bottom: 10px;
}
.manualContactDisable {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #d5dee6;
}
.btn-trms-medium {
  padding: 7px 21px;
  border: 1px solid #2e93a1;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1;
  background-color: #2e93a1;
  height: 35px;
  min-width: 140px;
}
.loading-preview {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 4px;
  border: solid 1px #d9d9d9;
}
.no-data-internal-user {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  text-align: center;
  margin: 10px 0px;
  padding: 10px;
}
.personal-email {
  color: #484b59;
  text-decoration: underline;
}
.btn-trms-medium.bg-gray {
  background-color: #969696 !important;
  color: #fff !important;
  border: 0px !important;
}
.filterContainer {
  width: 50%;
  float: left;
  position: relative;
}
.w3-animate-left {
  position: relative;
  animation: animateleft 0.4s;
}
@keyframes animateleft {
  from {
    right: -300px;
    opacity: 0;
  }
  to {
    right: 0;
    opacity: 1;
  }
}
.w3-animate-opacity {
  animation: opac 0.8s;
}
@keyframes opac {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.w3-overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 7;
}
.w3-sidebar {
  height: 100%;
  width: 55%;
  background-color: #fff;
  position: fixed !important;
  z-index: 1;
  overflow: auto;
  overflow-x: hidden;
  right: 0;
  top: 0;
  padding: 0px 15px 0px 15px;
  transition: display 0.5s;
  display: none;
}
.w3-animate-left {
  position: relative;
  animation: animateleft 0.4s;
}
.w3-animate-opacity {
  animation: opac 0.8s;
}
.tabdata-c {
  width: 100%;
  float: left;
  height: 100%;
  margin-bottom: 10px;
}
.tabdata-c .tab-col-1 {
  width: 150px;
  float: left;
  height: 100%;
}
.tabdata-c .tab-col-2 {
  width: calc(100% - 150px);
  float: left;
  height: 100%;
}
.selectdrop-down .fa-chevron-down {
  display: block;
}
.selectdrop-down .fa-chevron-up {
  display: none;
}
.tr0 {
  right: 10px;
  top: 10px;
}
.tr0 .fa-chevron-down {
  display: block;
}
.tr0 .fa-chevron-up {
  display: none;
}
.roleinput:focus .tr0 .fa-chevron-down {
  display: none;
}
.roleinput:focus .tr0 .fa-chevron-up {
  display: block;
}
.wc-ats-chip {
  padding: 5px 15px;
  background-color: #fafbfc;
  font-size: 14px;
  border-radius: 16px;
}
.wc-ats-chip span i {
  font-size: 14px;
  color: #484b59;
}
.preview {
  position: absolute;
  left: 92px;
  top: 50%;
  z-index: 5;
}
.back-green {
  background-color: #67c6bb;
}
.ndfHFb-c4YZDc-q77wGc {
  display: none;
}
span.dropdown-menu.show {
  position: absolute;
  left: -35px !important;
}
.nav-link {
  display: block;
  padding: 0.5rem 0.5rem;
}
.wcAccordianUpDownArrow {
  position: static;
  display: inline-block;
}
.btn-link {
  font-weight: 400;
  color: #484b59;
  text-decoration: none;
}
button.btn-link {
  color: #484b59;
}
button.btn-link .wcAccordianUpDownArrow .test1 {
  display: block;
  transition: display 0.4s;
}
button.btn-link .wcAccordianUpDownArrow .test2 {
  display: none;
  transition: display 0.4s;
}
button.collapsed {
  color: #484b59;
}
button.collapsed .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
button.collapsed .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
a.text-black:hover {
  color: #4dc7f4 !important;
}
.custText {
  color: white;
  font-size: 18px;
  white-space: nowrap;
  height: 50px;
}
.custCross {
  padding-left: 100%;
  size: 20px;
}
.pvtgdprLabel {
  box-shadow: 0 0 1px 0 #e1d9d9;
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 2px;
  margin-right: 15px;
  border: 1px solid #cccccc;
}
.nav-pills .nav-link {
  border-radius: 3px;
  background-color: transparent;
  color: #2C2C2C;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #206C79;
  border-radius: 0px;
  font-weight: 500;
  background-color: transparent;
  border-bottom: 2px solid #206C79;
}
.trx {
  padding-right: 10px;
}
.r0 {
  right: 0;
}
.lh {
  line-height: 6px !important;
}
.onhverEdit {
  display: none;
}
.onHover:hover .onhverEdit {
  display: block;
}
.canProfilePic {
  width: 60px;
  height: 60px;
  background-color: rgba(48, 5, 127, 0.04);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 24px;
  overflow: hidden;
  border-radius: 100px;
}
.canProfilePic:hover .onHoverPicChange {
  visibility: visible;
  opacity: 1;
  transition: all 0.5s;
}
.canProfilePic .onHoverPicChange {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.25);
  color: white;
  position: absolute;
  visibility: hidden;
  opacity: 0;
  transition: all 0.5s;
}
.canProfilePic img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
  border-radius: 4px;
}
.canProfilePic img:hover + .onHoverPicChange {
  visibility: visible;
  opacity: 1;
  transition: all 0.5s;
}
.canProfilePic i {
  font-size: 40px;
}
.boxed-available {
  height: 16px;
  width: 69px;
  border-radius: 2px;
  background-color: #AF2C2C;
  color: white;
  text-align: center;
  padding: 2px;
}
.p-left {
  padding-left: 5px;
}
.float-right {
  float: right;
}
.tr-n {
  right: 25px;
  bottom: 7px;
}
.wc-form-control-activity {
  padding: 3px 10px !important;
  height: 27px !important;
  width: 100% !important;
}
.footerbtn {
  width: 100%;
  height: 50px;
  border-radius: 2px;
  background-color: #2E93A1;
  bottom: 0;
  text-align: -webkit-center;
  display: inline-block;
  left: 0;
}
.input-disabled {
  pointer-events: none;
  color: grey;
}
::-webkit-input-placeholder {
  font-size: 13px !important;
}
::-moz-placeholder {
  font-size: 13px !important;
}
:-ms-input-placeholder r {
  font-size: 13px !important;
}
:-moz-placeholder {
  font-size: 13px !important;
}
.p-left {
  padding-left: 5px;
}
.float-right {
  float: right;
}
.ats-dropBtn .dropdown-menu {
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
}
.ats-dropBtn .dropdown-menu a.dropdown-item:hover {
  color: #4A90E2;
  background-color: #EBF0F4;
}
.btn-break {
  padding: 0;
  border: none;
  color: #206C79;
  outline: none;
  background-color: #fff;
}
::-webkit-scrollbar {
  width: 4px;
}
:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
::-webkit-scrollbar-track {
  background: white !important;
}
::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.webtree-btn {
  padding: 3px 4px 4px 4px !important;
  text-align: center;
}
.ip {
  color: #CCCCCC !important;
  pointer-events: none;
  cursor: default;
}
.ap {
  color: #484b59 !important;
}
.p-none {
  pointer-events: none;
}
.fa-gravatar:before {
  content: "\f1a0";
}
.fa-gravatar {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
}
.webtree-btn-1 {
  color: #2E93A1;
  width: 25px;
  height: 25px;
  padding: 6px 2px 2px 6px !important;
}
.covered_slider {
  height: calc(100% - 80px);
  overflow: auto;
  overflow-x: hidden;
}
.br-1 {
  border-right: 1px solid #979797;
}
.f-poppins {
  font-family: Poppins;
}
.spacer-border {
  border-right: 1px dashed #979797;
}
.h-105 {
  height: 105px;
}
.sidebar-transition {
  display: none;
  z-index: 1031;
  transition: all 5s;
}
.pos-abs-bottom-0 {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.close-overlay-transition {
  cursor: pointer;
  transition: all 5s;
}
.premium-enriched {
  font-size: 10px !important;
  background-color: #af2c2c;
  color: #fff;
  margin-left: 5px !important;
  padding: 4px;
  text-align: center;
  cursor: pointer;
  white-space: pre;
}
.no-premium-enriched {
  font-size: 10px !important;
  background-color: #969696 !important;
  color: #fff;
  margin-left: 5px !important;
  padding: 4px;
  text-align: center;
  cursor: pointer;
  white-space: pre;
}
.dot {
  position: relative;
  color: #ffd200;
  right: 6px;
  top: -8px;
  font-size: 7px;
  margin-right: -5px;
}
::ng-deep .ce_tooltip_class.tooltip.show {
  left: 50px !important;
}
::ng-deep #tool + ngb-tooltip-window .bs-tooltip-auto[x-placement^=bottom] .arrow::before,
::ng-deep #tool2 + ngb-tooltip-window .bs-tooltip-auto[x-placement^=bottom] .arrow::before,
::ng-deep .bs-tooltip-bottom .arrow::before {
  right: 70px;
}
::ng-deep .ce_tooltip_class .tooltip-inner {
  width: 252px !important;
  background-color: white;
}
.btn-files {
  color: #2E93A1;
  border: 1px solid #2E93A1;
  background-color: white;
  text-align: center;
}
.iframe-div {
  width: 100%;
  height: 60vh;
}
.text-yellow {
  color: #ffd200;
}
.lastupdated {
  display: none;
}
.xda:hover .lastupdated {
  display: block;
  margin-top: 5px !important;
  position: absolute;
  right: 0;
  background-color: #fff;
  padding-left: 15px;
  color: #777777 !important;
}
.xda:hover .hover-width {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.social-media-icon {
  color: white;
  width: 25px;
  background-color: #000;
  height: 25px;
  text-align: center;
  border-radius: 15px;
  line-height: 25px;
  font-size: 12px;
}
.fa-linkedin {
  color: #0652ba !important;
}
.fa-angellist {
  background-color: #000 !important;
}
.fa-facebook {
  color: #1773ea !important;
}
.fa-globe {
  background-color: white !important;
}
.fa-behance {
  background-color: #1769ff !important;
}
.fa-square-x-twitter {
  color: #000 !important;
}
.fa-quora {
  background-color: #B92B27 !important;
}
.fa-address-card {
  background-color: #000 !important;
}
.fa-google {
  background-color: #dd4b39 !important;
}
.fa-youtube {
  background-color: #e52d27 !important;
}
.fa-flickr {
  background-color: #ff0084 !important;
}
.fa-foursquare {
  background-color: #0072b1 !important;
}
.fa-gravatar {
  background-color: #0074a2 !important;
}
.fa-instagram {
  background-color: #e4405f !important;
}
.fa-stack-overflow {
  background-color: #E8770F !important;
}
.fa-dribbble {
  background-color: #E54786 !important;
}
.fa-reddit {
  background-color: #15AABF !important;
}
.fa-pinterest {
  background-color: #E11A21 !important;
}
.dashed-more {
  width: 25px;
  border: 1px dashed #2E93A1;
  height: 25px;
  border-radius: 50%;
  font-size: 12px;
  padding: 3px;
  color: #2E93A1;
  font-weight: 700;
}
.copy {
  visibility: hidden !important;
  cursor: pointer;
  top: 5px;
}
.xda:hover .copy {
  visibility: visible !important;
}
.free-div {
  background-color: #2e93a1;
  color: #fff;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 5px;
  border-radius: 2px;
  margin-bottom: 5px;
}
.disabled-social {
  background-color: #969696 !important;
  color: #fff !important;
  pointer-events: none;
}
.text-blue {
  color: #2e93a1 !important;
}
.text-red {
  color: #af2c2c;
}
.dnone {
  display: none !important;
}
.text-copied {
  position: absolute;
  top: 20px;
  background-color: black;
  color: white;
  padding: 6px;
  z-index: 5;
  border-radius: 5px;
  font-size: 12px;
}
.d-hidden {
  visibility: hidden;
}
.d-visible {
  visibility: visible !important;
}
.star-bg {
  background-color: red;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  justify-content: center;
  font-size: 8px !important;
  align-items: center;
  padding: 3px 3px 4px;
  background-color: #af2c2c;
}
.fa-star {
  color: #ffd200;
  font-size: 8px;
}
.text-b3b3 {
  color: #b3b3b3;
}
.new-primary {
  font-size: 8px;
  margin-left: 0.25rem !important;
  color: #229300;
  background-color: #d7ffc4;
  font-weight: 600;
  display: inline-block;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-top: 4px;
  padding-left: 4px;
  padding-top: 2px;
}
.p-none {
  pointer-events: none !important;
}
.addDocuments {
  width: 100%;
  padding: 22px;
  border: dashed 1px #2e93a1;
  border-radius: 4px;
  text-align: center;
}
.empty-div {
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 5px;
  border-radius: 2px;
  margin-bottom: 5px;
}
.text-5757 {
  color: #575757;
}
.label-new {
  background-color: #e4f1f3;
  border-radius: 16px;
  padding: 3px 12px;
  color: #484b59;
  font-size: 12px;
  margin-right: 6px;
  margin-bottom: 8px;
  display: inline-flex;
}
.clogo {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid rgba(48, 5, 127, 0.04);
  background-color: rgba(48, 5, 127, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  color: #999;
  overflow: hidden;
}
.clogo img {
  width: 100%;
  height: auto;
}
.contactP {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background-color: #1769ff;
  color: #fff;
  font-size: 10px;
}
input[type=radio] {
  accent-color: #2e93a1;
}
.smlogo {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background-color: #2E93A1;
}
label.d-flex {
  border-radius: 4px;
  border: solid 1px #2e93a1;
  padding: 6px;
}
.coincount {
  background-color: #f2f2f2;
  padding: 2px 6px;
  font-size: 12px;
}
.bglightblue {
  background-color: rgba(46, 147, 161, 0.1);
}
.note-icon {
  background-color: #fef7eb;
  color: #f4ab33;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
ul.activivtyui li {
  list-style-type: none;
  padding-left: 15px;
}
ul.activivtyui li:before {
  content: "\b7";
  font-size: 100px;
  line-height: 50px;
  vertical-align: middle;
}
.tagslabel {
  border-radius: 13.5px;
  border: solid 0.5px #f2f2f2;
  background-color: #fff;
  padding: 0px 10px 0px 0px;
  margin-right: 10px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  list-style: 1.5;
  color: #969696;
}
.tagslabel .tagicon {
  width: 20px;
  height: 20px;
  flex-grow: 0;
  margin: 0 4px 0 0;
  padding: 5px 4px 3px 5px;
  background-color: rgba(46, 161, 120, 0.1);
  border-radius: 50%;
  color: #2dc3a5;
  display: flex;
}
.addTags {
  width: 20px;
  height: 20px;
  padding: 4px 4px 4px 4px;
  border: solid 0.5px #2e93a1;
  background-color: rgba(46, 161, 120, 0.1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #2e93a1;
  border-radius: 50%;
}
.dropdown-menu.show.px-2 {
  width: 360px;
  left: 50px !important;
}
.addTagleble {
  padding: 2px 8px;
  border-radius: 23px;
  border: solid 0.3px #d9d9d9;
  background-color: #fff;
  display: inline-flex;
  align-items: center;
  color: #484b59;
  font-size: 12px;
}
.addTagleble .fa-tag {
  color: #2dc3a5;
}
.custom-input {
  position: relative;
}
.custom-input input {
  width: 100%;
  height: 2.5rem;
  background-color: transparent;
  outline: none;
}
.custom-input .buttons {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
}
.custom-input .buttons .check-btn,
.custom-input .buttons .cancel-btn {
  width: 1.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
}
.custom-input .buttons .check-btn {
  color: #40BF02;
}
.custom-input .buttons .cancel-btn {
  color: #CD0F0F;
}
.onhoverdisplay {
  display: block;
}
.onHover:hover .onhoverdisplay {
  display: none;
}
.dropbtn,
.dropdown2 {
  background-color: #edf6f4;
  color: #008061;
  border-radius: 0.1875rem;
  font-weight: 500;
  padding: 0.375rem 0.375rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: none;
}
.dropdown,
.dropdown2 {
  position: relative;
  display: inline-block;
}
.dropdown-content {
  display: none;
  position: absolute;
  min-width: 160px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.22);
  z-index: 1;
  background-color: #fff;
  border-radius: 0.1875rem;
  padding: 0.625rem 0.625rem;
  color: #008061;
}
.dropdown:hover .dropdown-content {
  display: block;
  left: -130px;
  top: 22px;
}
.dropdown-content div:last-of-type > a {
  border-bottom: none;
  margin-bottom: 0px;
}
.dropdown2 {
  background-color: #fff;
  color: #484b59;
  border-radius: 0.1875rem;
  font-weight: 500;
  padding: 0;
}
.dropdown-content {
  color: #484b59;
  display: none;
  left: 26px;
  top: 20px;
  max-width: 320px;
  width: 400px;
  line-height: 1;
}
.dropdown-content p {
  line-height: 1.3;
}
.line-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.addToBtn {
  border-radius: 2px;
  background-color: #e1f4f1;
  color: #2e93a1;
  border: none;
  padding: 7px 21px;
  line-height: 1;
  font-size: 14pxpx;
  height: fit-content;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  text-indent: 1px;
  text-overflow: "";
}
a.dropdown-item {
  padding: 5px 7px;
}
.closeicon {
  padding: 2px 4px;
  position: absolute;
  right: -20px;
  top: -18px;
  line-height: 1;
  cursor: pointer;
  background: #fff;
  color: #484b59;
  z-index: 1;
  border: 1px solid #969696;
  border-radius: 50%;
}
.tagboxheight {
  width: calc(100% - 190px);
  height: 62px;
  overflow: hidden;
}
#backgroundOverlay {
  background-color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
}
.newContactui {
  border: solid 0.5px #d9d9d9;
  background-color: #fff;
  border-radius: 4px;
}
.newContactui .toprow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 10px;
}
.newContactui .toprow .coinsStack {
  padding: 2px 6px 2px 2px;
  border-radius: 17px;
  background-color: #e8ecf1;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: -2px;
}
.newContactui .toprow .coinsStack .coinicon {
  width: 23px;
  height: 23px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2e93a1;
  color: #ffe500;
  font-size: 12px;
  font-weight: normal;
}
.newContactui .bottomrow {
  padding: 5px 10px;
  display: flex;
  align-items: center;
  border-top: 1px solid #d9d9d9;
}
.newContactui .bottomrow .availableContacts {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e8ecf1;
  color: #229300;
  font-size: 12px;
  font-weight: normal;
  margin-left: 13px;
}
.primary-tag {
  padding: 1px 5px 1px 6px;
  border-radius: 2px;
  background-color: #ffd300;
  display: flex;
  align-items: center;
}
.contact-tag {
  border-radius: 18px;
  background-color: #efeff0;
  padding: 2px 6px;
}
.helpful-tag {
  border-radius: 18px;
  border: solid 0.6px #d5dee6;
  background-color: #fff;
  padding: 1px 9px;
}
.onHoverActions {
  display: none;
}
.onHover:hover .onHoverActions {
  display: flex;
}
.text-9696 {
  color: #969696 !important;
}
.dstooltip {
  position: relative;
  display: inline-block;
}
.dstooltip-content {
  display: none;
  position: absolute;
  min-width: 360px;
  width: 360px;
  box-shadow: 0 4px 10px 0 rgba(46, 147, 161, 0.2);
  top: 18px;
  z-index: 1;
}
.dstooltip:hover .dstooltip-content {
  display: block;
}
.dropup:hover .dropbtn {
  background-color: #2980B9;
}
.chipsnew {
  background-color: #e4f1f3;
  border-radius: 18px;
  font-size: 12px;
  font-weight: 500;
  padding: 3px 6px;
  max-width: 150px;
  width: auto;
  margin-bottom: 5px;
}
.c-pointer {
  cursor: pointer;
}
.wc-checkbox {
  width: 15px !important;
  height: 15px !important;
  position: relative;
  left: 0;
  top: 0;
  cursor: pointer;
}
.wc-checkbox input[type=checkbox] {
  left: 0;
  right: 0;
  width: 15px;
  height: 15px;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
}
.text-uiniversity {
  max-width: calc(100% - 120px);
}
.w-120px {
  width: 120px;
}
.onHover.border-bottom:last-child {
  border-bottom: none !important;
  margin-bottom: 5px !important;
}
.disabled {
  background-color: gray;
  border: 1px solid gray;
  cursor: default;
}
.rectangle-img {
  width: 100px;
  background-color: #2e93a1;
  height: 32px;
  clip-path: polygon(100% 0%, 90% 50%, 100% 100%, 0 97%, 0% 50%, 0 0);
  color: #fff !important;
  font-size: 12px;
  font-weight: 600;
}
.aegis-connection {
  background: #edf3f5;
  border-radius: 8px;
  border: 1px solid #dbe6eb;
  overflow: hidden;
  margin-top: 2px;
}
.aegis-connection__header {
  border-bottom: 1px solid #dbe6eb;
  background: #edf3f5;
  min-height: 60px;
}
.aegis-connection__logo-icon {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.aegis-connection__dot {
  color: #bcc9d1;
  font-weight: 700;
  line-height: 1;
}
.aegis-connection__name {
  color: #404653;
  font-size: 15px;
  line-height: 1.1;
  letter-spacing: 0;
}
.aegis-connection__badge {
  background: #d5e9ee;
  border: 0;
  border-radius: 20px;
  padding: 3px 12px;
  color: #2c9cad;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}
.aegis-connection__badge-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2c9cad;
}
.aegis-connection__link {
  color: #2c9cad;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
}
.aegis-connection__link:hover {
  text-decoration: underline;
}
.aegis-connection__details {
  background: #edf3f5;
  flex-wrap: wrap;
  gap: 16px;
  min-height: 86px;
}
.aegis-connection__detail-item {
  min-width: 145px;
}
.aegis-connection__detail-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f3f3f3;
  color: #a2a2a2;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.aegis-connection__detail-label {
  color: #9a9da4;
  font-size: 11px;
  line-height: 1.1;
}
.aegis-connection__detail-value {
  color: #404653;
  font-size: 13px;
  line-height: 1.2;
}
@media (max-width: 991px) {
  .aegis-connection__name {
    font-size: 14px;
  }
  .aegis-connection__badge {
    font-size: 11px;
    padding: 4px 10px;
  }
  .aegis-connection__link {
    font-size: 12px;
  }
  .aegis-connection__details {
    gap: 12px;
  }
  .aegis-connection__detail-item {
    min-width: 140px;
  }
  .aegis-connection__detail-label,
  .aegis-connection__detail-value {
    font-size: 12px;
  }
}
@media (max-width: 640px) {
  .aegis-connection__header {
    align-items: flex-start !important;
    gap: 10px;
    flex-direction: column;
  }
  .aegis-connection__details {
    gap: 10px;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  .aegis-connection__detail-item {
    min-width: 48%;
    margin-right: 0 !important;
  }
}
.hire-btn-primary {
  background-color: #2E93A1;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #2E93A1;
}
.hire-btn-success {
  background-color: #28a745;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #28a745;
}
.hire-btn-danger {
  background-color: #dc3545;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #dc3545;
}
.hire-btn-warning {
  background-color: #ffc107;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #ffc107;
}
.hire-btn-secondary {
  background-color: #ffffff;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #D5DEE6;
  color: #2E93A1;
}
.filter-layout {
  background: #fff;
  overflow: hidden;
  position: relative;
}
.fl-header {
  width: 100%;
  height: auto;
  background-color: #F2F2F2;
  display: flex;
  align-items: center;
  padding: 16px 20px;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 1;
}
.fl-container {
  display: flex;
  width: 100%;
}
.fl-container .side-panel {
  width: 32%;
  display: flex;
  padding: 12px 12px;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
  border-right: 1px solid #EEF2F5;
}
.fl-container .side-panel .tab-list {
  list-style: none;
  margin: 0;
  padding: 0 0px;
  flex: 1;
  overflow-y: auto;
}
.fl-container .side-panel .tab-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 12px;
  margin-bottom: 0px;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.18s ease, color 0.18s ease;
  color: #484b59;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  -webkit-user-select: none;
  user-select: none;
}
.fl-container .side-panel .active {
  border-radius: 4px;
  background-color: #F4F9FA;
  font-weight: 500;
}
.fl-container .side-panel .active .tab-icon {
  filter: drop-shadow(0 0 6px rgba(108, 140, 255, 0.25));
}
.fl-container .side-panel .list-group {
  border: none;
  width: 100%;
}
.fl-container .side-panel .list-group .list-group-item {
  border: none;
  padding: 12px 6px;
  display: flex;
  align-items: center;
}
.fl-container .side-panel .list-group .list-group-item span {
  margin-right: 5px;
}
.fl-container .content-body {
  display: flex;
  width: 68%;
  height: calc(100vh - 100px);
  overflow-y: auto;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  scroll-behavior: smooth;
}
.fl-container .content-body::-webkit-scrollbar {
  width: 4px;
}
.fl-container .content-body::-webkit-scrollbar-track {
  background: transparent;
}
.fl-container .content-body::-webkit-scrollbar-thumb {
  background: #F2F2F2;
  border-radius: 3px;
}
.fl-container .content-body .filter-groups-section {
  width: 100%;
  margin-bottom: 24px;
}
.fl-container .content-body .filter-groups-section:last-child {
  padding-bottom: 200px;
}
.fl-container .content-body textarea.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  min-height: 100px;
}
.fl-container .content-body input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
.fl-container .content-body select.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 4px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
.fl-container .content-body .label-style {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 6px;
}
.fl-container .content-body .dropdown-caret {
  position: relative;
  width: fit-content;
}
.fl-container .content-body .dropdown-caret::after {
  content: "";
  display: flex;
  position: absolute;
  right: 3px;
  top: 5px;
  width: 12px;
  height: 12px;
  color: #484b59;
  font-size: 12px;
  transition: rotate 0.3s ease;
  background-image: url("./media/caret-down-S5OF35ZE.svg");
  background-size: contain;
  background-repeat: no-repeat;
}
.fl-container .content-body .dropdown-caret.distance-dropdown select.caret-remove {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 80px;
}
.fl-container .content-body .dropdown-caret.distance-dropdown::after {
  right: 7px;
  top: 8px;
}
.fl-container .content-body .custom-select {
  min-width: 50px;
  width: 70px;
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
  color: #484b59;
}
.fl-container .content-body .custom-select:focus {
  outline: none;
  border-color: #007bff;
}
.fl-container .content-body select.custom-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.fl-container .content-body select.caret-remove {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 70px;
}
.fl-container .content-body select.caret-remove2 {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 105px;
}
.highlight-pill {
  max-width: max-content;
  width: -moz-max-content;
  width: max-content;
  padding: 4px 8px;
  border-radius: 30px;
  align-items: center;
  font-weight: 12px;
  cursor: pointer;
  font-weight: 400;
}
.highlight-pill img {
  width: 12px;
}
.disabled-input {
  pointer-events: none;
  background-color: #eaeaea !important;
}
.save-input {
  background-color: #f8f8f8;
}
::ng-deep div.mat-mdc-autocomplete-panel {
  padding: 6px 0 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar {
  width: 4px;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-track {
  background: #f1f1f1 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-thumb {
  background: #969696 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel .mat-mdc-option {
  min-height: 30px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: inherit !important;
}
::ng-deep .p-multiselect-label.p-placeholder {
  font-size: 12px !important;
  color: #969696 !important;
  font-weight: normal !important;
}
::ng-deep .p-component * {
  box-sizing: border-box;
  width: auto !important;
  font-family: "Poppins", sans-serif;
  font-size: 12px !important;
  background: #ffffff;
}
::ng-deep .p-component .p-checkbox,
::ng-deep .p-component .p-checkbox {
  width: 16px !important;
  height: 16px !important;
  margin-right: 10px !important;
}
::ng-deep .p-component .p-checkbox .p-checkbox-input,
::ng-deep .p-component .p-checkbox .p-checkbox-input {
  width: 16px !important;
  height: 16px !important;
}
::ng-deep .p-component .p-checkbox .p-checkbox-input .p-checkbox-box,
::ng-deep .p-component .p-checkbox .p-checkbox-input .p-checkbox-box {
  width: 16px !important;
  height: 16px !important;
}
::ng-deep .p-component .p-checkbox .p-checkbox-box {
  width: 16px !important;
  height: 16px !important;
}
::ng-deep .p-multiselect-option {
  margin-bottom: 8px !important;
}
::ng-deep .p-multiselect-dropdown {
  position: relative;
}
::ng-deep .p-multiselect-dropdown svg {
  display: none !important;
  width: 12px !important;
  height: 12px !important;
}
::ng-deep .p-multiselect-dropdown svg path[fill~=currentColor] {
  color: #5E5E5E !important;
}
::ng-deep .p-multiselect-dropdown::after {
  content: "";
  display: block;
  position: absolute;
  right: 0;
  top: 2px;
  width: 12px;
  height: 12px;
  color: #484b59;
  font-size: 12px;
  transition: rotate 0.3s ease;
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  background-image: url("./media/caret-down-S5OF35ZE.svg");
  background-size: contain;
  background-repeat: no-repeat;
}
::ng-deep .p-multiselect-open .p-multiselect-dropdown::after {
  transform: rotate(180deg);
  transition: rotate 0.3s ease;
}
.fl-count {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 12px;
  background-color: #2E93A1;
}
::ng-deep span.mat-mdc-option.mdc-list-item--disabled {
  cursor: default;
  pointer-events: none;
}
.no-btn-text-only {
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0;
  color: #484b59;
  font-size: 12px;
}
::ng-deep ngb-tooltip-window .tooltip-inner {
  color: #ffffff;
  text-align: left;
  background-color: #484b59;
  max-width: 200px;
  width: 200px;
}
::ng-deep .mat-mdc-option.mdc-list-item--disabled {
  pointer-events: auto !important;
}
::ng-deep .mat-mdc-option.mdc-list-item--disabled .tooltip-wrapper {
  pointer-events: auto;
  cursor: not-allowed;
}
::ng-deep .mat-mdc-option.mdc-list-item--disabled .mdc-list-item__primary-text {
  pointer-events: none;
}
.ms-wrapper {
  position: relative;
}
.ms-wrapper .ms-fake-label {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  padding-left: 12px;
  background: var(--p-multiselect-background, #fff);
  pointer-events: none;
  z-index: 1;
}
:ng-deep .p-component * {
  width: 100% !important;
}
.hire-btn-primary {
  width: 90px;
}
.hire-btn-primary.disabled {
  background-color: #969696;
  border-color: #969696;
  pointer-events: none;
}
.remove-caret::after {
  display: none;
}
.hire-btn-primary.dropdown-toggle::after {
  display: none !important;
}
.filterContainer {
  width: 50%;
  float: left;
  position: relative;
}
.w3-animate-left {
  position: relative;
  animation: animateleft 0.4s;
}
@keyframes animateleft {
  from {
    right: -300px;
    opacity: 0;
  }
  to {
    right: 0;
    opacity: 1;
  }
}
.w3-animate-opacity {
  animation: opac 0.8s;
}
@keyframes opac {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.w3-overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 7;
}
.w3-sidebar {
  height: 100%;
  width: 25%;
  background-color: #fff;
  position: fixed !important;
  z-index: 1;
  overflow: auto;
  overflow-x: hidden;
  right: 0;
  top: 0;
  padding: 0px 15px 0px 15px;
  transition: display 0.5s;
  display: none;
}
.w3-animate-left {
  position: relative;
  animation: animateleft 0.4s;
}
.w3-animate-opacity {
  animation: opac 0.8s;
}
.tabdata-c {
  width: 100%;
  float: left;
  height: 100%;
  margin-bottom: 10px;
}
.tabdata-c .tab-col-1 {
  width: 150px;
  float: left;
  height: 100%;
}
.tabdata-c .tab-col-2 {
  width: calc(100% - 150px);
  float: left;
  height: 100%;
}
.selectdrop-down .fa-chevron-down {
  display: block;
}
.selectdrop-down .fa-chevron-up {
  display: none;
}
.tr0 {
  right: 10px;
  top: 10px;
}
.tr0 .fa-chevron-down {
  display: block;
}
.tr0 .fa-chevron-up {
  display: none;
}
.roleinput:focus .tr0 .fa-chevron-down {
  display: none;
}
.roleinput:focus .tr0 .fa-chevron-up {
  display: block;
}
.wc-ats-chip {
  padding: 5px 15px;
  background-color: #e4f1f3;
  font-size: 14px;
  border-radius: 16px;
  font-weight: 500;
}
.wc-ats-chip span i {
  font-size: 14px;
  color: #484b59;
  font-weight: 500;
}
.preview {
  position: absolute;
  left: 92px;
  top: 50%;
  z-index: 5;
}
.back-green {
  background-color: #67c6bb;
}
.ndfHFb-c4YZDc-q77wGc {
  display: none;
}
span.dropdown-menu.show {
  position: absolute;
  left: -35px !important;
}
.nav-link {
  display: block;
  padding: 0.5rem 0.5rem;
}
.wcAccordianUpDownArrow {
  position: static;
  display: inline-block;
}
.btn-link {
  font-weight: 400;
  color: #484b59;
  text-decoration: none;
}
button.btn-link {
  color: #484b59;
}
button.btn-link .wcAccordianUpDownArrow .test1 {
  display: block;
  transition: display 0.4s;
}
button.btn-link .wcAccordianUpDownArrow .test2 {
  display: none;
  transition: display 0.4s;
}
button.collapsed {
  color: #484b59;
}
button.collapsed .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
button.collapsed .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
a.text-black:hover {
  color: #4dc7f4 !important;
}
.custText {
  color: white;
  font-size: 18px;
  white-space: nowrap;
  height: 50px;
}
.custCross {
  padding-left: 100%;
  size: 20px;
}
.pvtgdprLabel {
  box-shadow: 0 0 1px 0 #e1d9d9;
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 2px;
  margin-right: 15px;
  border: 1px solid #cccccc;
}
.nav-pills .nav-link {
  border-radius: 3px;
  background-color: transparent;
  color: #2C2C2C;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #206C79;
  border-radius: 0px;
  font-weight: 500;
  background-color: transparent;
  border-bottom: 2px solid #206C79;
}
.trx {
  padding-right: 10px;
}
.r0 {
  right: 0;
}
.lh {
  line-height: 6px !important;
}
.onhverEdit {
  display: none;
}
.onHover:hover .onhverEdit {
  display: block;
}
.canProfilePic {
  width: 75px;
  height: 75px;
  background-color: rgba(48, 5, 127, 0.04);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 24px;
  overflow: hidden;
  border-radius: 100px;
}
.canProfilePic:hover .onHoverPicChange {
  visibility: visible;
  opacity: 1;
  transition: all 0.5s;
}
.canProfilePic .onHoverPicChange {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.25);
  color: white;
  position: absolute;
  visibility: hidden;
  opacity: 0;
  transition: all 0.5s;
}
.canProfilePic img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
  border-radius: 4px;
}
.canProfilePic img:hover + .onHoverPicChange {
  visibility: visible;
  opacity: 1;
  transition: all 0.5s;
}
.canProfilePic i {
  font-size: 40px;
}
.boxed-available {
  height: 16px;
  width: 69px;
  border-radius: 2px;
  background-color: #AF2C2C;
  color: white;
  text-align: center;
  padding: 2px;
}
.p-left {
  padding-left: 5px;
}
.float-right {
  float: right;
}
.tr-n {
  right: 25px;
  bottom: 7px;
}
.wc-form-control-activity {
  padding: 3px 10px !important;
  height: 27px !important;
  width: 100% !important;
}
.footerbtn {
  width: 100%;
  height: 50px;
  border-radius: 2px;
  background-color: #2E93A1;
  bottom: 0;
  text-align: -webkit-center;
  display: inline-block;
  left: 0;
}
.input-disabled {
  pointer-events: none;
  color: grey;
}
::-webkit-input-placeholder {
  font-size: 13px !important;
}
::-moz-placeholder {
  font-size: 13px !important;
}
:-ms-input-placeholder r {
  font-size: 13px !important;
}
:-moz-placeholder {
  font-size: 13px !important;
}
.p-left {
  padding-left: 5px;
}
.float-right {
  float: right;
}
.ats-dropBtn .dropdown-menu {
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
}
.ats-dropBtn .dropdown-menu a.dropdown-item:hover {
  color: #4A90E2;
  background-color: #EBF0F4;
}
.btn-break {
  padding: 0;
  border: none;
  color: #206C79;
  outline: none;
  background-color: #fff;
}
::-webkit-scrollbar {
  width: 4px;
}
:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
::-webkit-scrollbar-track {
  background: white !important;
}
::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.webtree-btn {
  padding: 3px 4px 4px 4px !important;
  text-align: center;
}
.ip {
  color: #CCCCCC !important;
  pointer-events: none;
  cursor: default;
}
.ap {
  color: #484b59 !important;
}
.p-none {
  pointer-events: none;
}
.fa-gravatar:before {
  content: "\f1a0";
}
.fa-gravatar {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
}
.webtree-btn-1 {
  color: #2E93A1;
  background-color: #D5E9EC;
  width: 25px;
  height: 25px;
  padding: 6px 2px 2px 6px !important;
}
.covered_slider {
  height: calc(100% - 80px);
  overflow: auto;
  overflow-x: hidden;
}
.br-1 {
  border-right: 1px solid #979797;
}
.f-poppins {
  font-family: Poppins;
}
.spacer-border {
  border-right: 1px solid #979797;
}
.h-105 {
  height: 105px;
}
.sidebar-transition {
  display: none;
  z-index: 1031;
  transition: all 5s;
}
.pos-abs-bottom-0 {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.close-overlay-transition {
  cursor: pointer;
  transition: all 5s;
}
.premium-enriched {
  font-size: 10px !important;
  background-color: #af2c2c;
  color: #fff;
  margin-left: 5px !important;
  padding: 4px;
  text-align: center;
  cursor: pointer;
  white-space: pre;
}
.no-premium-enriched {
  font-size: 10px !important;
  background-color: #969696 !important;
  color: #fff;
  margin-left: 5px !important;
  padding: 4px;
  text-align: center;
  cursor: pointer;
  white-space: pre;
}
.dot {
  position: relative;
  color: #ffd200;
  right: 6px;
  top: -8px;
  font-size: 7px;
  margin-right: -5px;
}
::ng-deep .ce_tooltip_class.tooltip.show {
  left: 50px !important;
}
::ng-deep #tool + ngb-tooltip-window .bs-tooltip-auto[x-placement^=bottom] .arrow::before,
::ng-deep #tool2 + ngb-tooltip-window .bs-tooltip-auto[x-placement^=bottom] .arrow::before,
::ng-deep .bs-tooltip-bottom .arrow::before {
  right: 70px;
}
::ng-deep .ce_tooltip_class .tooltip-inner {
  width: 252px !important;
  background-color: white;
}
.btn-files {
  color: #2E93A1;
  border: 1px solid #2E93A1;
  background-color: white;
  text-align: center;
}
.iframe-div {
  width: 100%;
  height: 60vh;
}
.text-yellow {
  color: #ffd200;
}
.lastupdated {
  display: none;
}
.xda:hover .lastupdated {
  display: block;
  margin-top: 5px !important;
  position: absolute;
  right: 0;
  background-color: #fff;
  padding-left: 15px;
  color: #777777 !important;
}
.xda:hover .hover-width {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.social-media-icon {
  color: white;
  width: 25px;
  background-color: #000;
  height: 25px;
  text-align: center;
  border-radius: 15px;
  line-height: 25px;
  font-size: 12px;
}
.fa-linkedin {
  background-color: #2e93a1 !important;
}
.fa-angellist {
  background-color: #000 !important;
}
.fa-facebook-f {
  background-color: #3b5998 !important;
}
.fa-globe {
  background-color: #484b59 !important;
}
.fa-behance {
  background-color: #1769ff !important;
}
.fa-square-x-twitter {
  background-color: #000 !important;
}
.fa-quora {
  background-color: #B92B27 !important;
}
.fa-address-card {
  background-color: #000 !important;
}
.fa-google {
  background-color: #dd4b39 !important;
}
.fa-youtube {
  background-color: #e52d27 !important;
}
.fa-flickr {
  background-color: #ff0084 !important;
}
.fa-foursquare {
  background-color: #0072b1 !important;
}
.fa-gravatar {
  background-color: #0074a2 !important;
}
.fa-instagram {
  background-color: #e4405f !important;
}
.fa-stack-overflow {
  background-color: #E8770F !important;
}
.fa-dribbble {
  background-color: #E54786 !important;
}
.fa-reddit {
  background-color: #15AABF !important;
}
.fa-pinterest {
  background-color: #E11A21 !important;
}
.dashed-more {
  width: 25px;
  border: 1px dashed #2E93A1;
  height: 25px;
  border-radius: 50%;
  font-size: 12px;
  padding: 3px;
  color: #2E93A1;
  font-weight: 700;
}
.copy {
  visibility: hidden !important;
  cursor: pointer;
  top: 5px;
}
.xda:hover .copy {
  visibility: visible !important;
}
.free-div {
  background-color: #2e93a1;
  color: #fff;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 5px;
  border-radius: 2px;
  margin-bottom: 5px;
}
.disabled-social {
  background-color: #969696 !important;
  color: #fff !important;
  pointer-events: none;
}
.text-blue {
  color: #2e93a1 !important;
}
.text-red {
  color: #af2c2c;
}
.dnone {
  display: none !important;
}
.text-copied {
  position: absolute;
  top: 20px;
  background-color: black;
  color: white;
  padding: 6px;
  z-index: 5;
  border-radius: 5px;
  font-size: 12px;
}
.d-hidden {
  visibility: hidden;
}
.d-visible {
  visibility: visible !important;
}
.star-bg {
  background-color: red;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  justify-content: center;
  font-size: 8px !important;
  align-items: center;
  padding: 3px 3px 4px;
  background-color: #af2c2c;
}
.fa-star {
  color: #ffd200;
  font-size: 8px;
}
.text-b3b3 {
  color: #b3b3b3;
}
.new-primary {
  font-size: 8px;
  margin-left: 0.25rem !important;
  color: #229300;
  background-color: #d7ffc4;
  font-weight: 600;
  display: inline-block;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-top: 4px;
  padding-left: 4px;
  padding-top: 2px;
}
.p-none {
  pointer-events: none !important;
}
.filterContainer {
  width: 30%;
  float: left;
  position: relative;
}
.tr0 {
  right: 10px;
  top: 10px;
}
.card {
  border-left: none;
  border-right: none;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.card-header {
  padding: 0.5rem 0rem;
  margin-bottom: 0;
  background-color: rgba(255, 255, 255, 0.03);
  border-bottom: none;
}
.card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.btn-link {
  font-weight: 400;
  color: #484b59;
  text-decoration: none;
}
button.btn-link,
a.btn-link {
  color: #484b59;
}
button.btn-link .wcAccordianUpDownArrow .test1,
a.btn-link .wcAccordianUpDownArrow .test1 {
  display: block;
  transition: display 0.4s;
}
button.btn-link .wcAccordianUpDownArrow .test2,
a.btn-link .wcAccordianUpDownArrow .test2 {
  display: none;
  transition: display 0.4s;
}
button.collapsed,
a.collapsed {
  color: #484b59;
}
button.collapsed .wcAccordianUpDownArrow .test1,
a.collapsed .wcAccordianUpDownArrow .test1 {
  display: none;
  transition: display 0.4s;
}
button.collapsed .wcAccordianUpDownArrow .test2,
a.collapsed .wcAccordianUpDownArrow .test2 {
  display: block;
  transition: display 0.4s;
}
.wcAccordianUpDownArrow {
  position: absolute;
  right: 0;
}
.wc-ats-chip {
  display: inline-flex;
}
.filterContainer {
  width: -webkit-fill-available;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 15px;
  margin: 0 -15px;
}
::-webkit-scrollbar {
  width: 3px;
  position: absolute !important;
  right: 30px !important;
  display: none;
}
.filterContainer::-webkit-scrollbar-track {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  position: absolute !important;
  right: 30px !important;
}
.filterContainer::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: rgba(199, 199, 199, 0.8);
  position: absolute !important;
  right: 30px !important;
}
.filterContainer::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 0, 0, 0.4);
}
.customeRadioBtn {
  display: block;
  position: relative;
  padding-left: 20px;
  margin-bottom: 0px;
  cursor: pointer;
  font-size: 14px;
  margin-right: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.customeRadioBtn input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  left: 0;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #fff;
  border-radius: 50%;
  border: 2px solid #2e93a1;
  margin-top: 2px;
}
.customeRadioBtn input:checked ~ .checkmark {
  border: 2px solid #2e93a1;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.customeRadioBtn input:checked ~ .checkmark:after {
  display: block;
}
.customeRadioBtn .checkmark:after {
  top: 2px;
  left: 2px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2e93a1 content-box;
}
.multi-select-container {
  display: flex;
  flex-direction: column;
}
.multi-select-option {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.selected-option {
  background-color: #e0e0e0;
  padding: 4px;
  margin-right: 4px;
  border-radius: 4px;
  display: inline-block;
}
.fl-container form {
  width: 100%;
}
.fl-container .content-body {
  width: 100%;
  display: block;
}
.fl-container .content-body::-webkit-scrollbar {
  width: 4px;
  display: block;
}
.email-block {
  padding: 20px 20px 35px;
  border-radius: 4px;
  background-color: #f6f6f6;
}
.email-contact-slider {
  margin-top: -15px;
  margin-left: -15px;
  margin-right: -15px;
}
/*# sourceMappingURL=email-campaign-candidate-slider.component-MJI4EAER.css.map */
